import React, { Component } from "react";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import {
  actionAddArray2Redux,
  selectARecord,
  initSelectedRecord,
  setUiFlag,
  loadAllStats,
  resetRedux,
  loadFbData,
  notifyUsers,
  getId,
  getAcctStatement,
  getAcctBalance,
  actionUpdateRecord2Redux,
  fetchDistance,
  initialFetch,
  initialProductsFetch,
  reachApi,
  reachApiExtended,
  getStatementB64
} from "../../../../store/actions";
import WorkerGrid from "../ContentGrid/WorkerGrid";
import ContentGridVanilla from "../ContentGrid/ContentGridVanilla";
import OpenBazarGrid from "../ContentGrid/OpenBazarGrid";
import AdminGrid from "../ContentGrid/AdminGrid";
import MyShopGrid from "../ContentGrid/MyShopGrid";
import getDefs from "../../../../staticData/getDefs";
import { searchRecords } from "../../searches/searchRecords";
import { getMenuList, getInitData, getCaption } from "./getMenuList";
import "./landingPage.css";
import { throttle, debounce } from "throttle-debounce";
import GridFilters from "../ContentGrid/GridFilters";
import GridDateFilters from "../ContentGrid/GridDateFilters";
import { isMobile } from "react-device-detect";
import getExtendedOgDefs from "../../TableDefinitions/extendedOgDef";
import getInputField from "../customFields/getInputField";
import DirectAdmin from "./DirectAdmin";
import { localState } from "../../../../staticData/rawState";
import termsMainPage from "./termsMainPage";
import { FirebaseAuth } from "react-firebaseui";
import { logoB64Text } from "./imageText";
import { bcsShopImage } from "./bcsShopImage.js";
import { bcsOpenBazarImage } from "./bcsOpenBazarImage.js";
import { bcsPassportSvcImage } from "./bcsPassportSvcImage.js";
import { hcommImage } from "./hcommImage.js";
import SingleRecord from "../SingleRecord/SingleRecord";
import BuyFromShopGrid from "../ContentGrid/BuyFromShopGrid";
import OrderPadDirectSupplier from "./OrderPadDirectSupplier";
import BgdPassportService from "./BgdPassportService";
import BgdPassportServiceExt from "./BgdPassportServiceExt";
import RemitService from "./RemitService";
import { getMarketingBox } from "./getMarketingBox";
import numeral from "numeral";
import moment from "moment";
import YouTube from "react-youtube";
import { TextField } from "reactackle";
import HighComm from "./HighComm";
import { tSupplierShopItems } from "../../../../staticData/tSupplierShopItems";
import AgraniService from "./AgraniService";
import PrimeExchService from "./PrimeExchService";

//import LogRocket from "logrocket";
//import setupLogRocketReact from "logrocket-react";

class Workers extends Component {
  constructor(props) {
    super(props);
    ////console.log("...test... " + JSON.stringify(tableDefs));
    //console.log(window.location.hostname + " " + JSON.stringify(localState));
    //LogRocket.init("1gfaw4/bcsprod");
    //setupLogRocketReact(LogRocket);
    let crTable = _.cloneDeep(this.props.createTable);
    let tDefs = getDefs(crTable);
    let extDefs = getExtendedOgDefs(crTable);
    this.state = {
      data: {
        path: "",
        payload: {
          paymentType: "",
          supplierInvoice: "",
          referenceNumber: "",
          paymentDate: ""
        }
      },
      message: "",
      hasLoaded: false,
      tableName: "deliveryRequest",
      testing: false,
      searchVal: "",
      showGrid: true,
      showDash: false,
      searchFilters: { category: "POPULAR" },
      searchDateFilters: {},
      showPivot: false,
      reRenderFlag: false,
      tableDefs: tDefs,
      formDefs: extDefs,
      notInitialized: true,
      loginProgress: false,
      logview: [],
      stage: "login", //default prod stage should be login
      loginProgress: false,
      localhost: localState.hostname,
      startButtonText: "LOADING ...",
      isSignedIn: false,
      notLoadedBasicData: true,
      showFilters: false,
      sortByLatest: false,
      showMenu: false,
      showPreLoader: true
    };
    this.getDataDebounced = debounce(1000, this.doStateUpdateForSearch);
    this.getDataThrottled = throttle(1000, this.doStateUpdateForSearch);
  }

  // getStaticDataForRedux = (path, data) => {
  //   //console.log("adding: " + path);
  //   let tmpArray = [];
  //   Object.keys(data).map(key => {
  //     let item = {
  //       ...data[key],
  //       key: key
  //     };
  //     tmpArray.push(item);
  //   });
  //   tmpArray.reverse();
  //   console.log(path);
  //   console.log(JSON.stringify(tmpArray));
  //// this.props.onAddRecord({
  ////   path: path,
  ////   payload: tmpArray
  //// });
  // };

  componentDidMount() {
    //console.log("mounted now...");
    let scDiv = window.document.getElementById("oDiv");
    if (scDiv && scDiv !== undefined) {
      scDiv.addEventListener("scroll", this.handleScroll);
    }
    try {
      if (
        this.state.notInitialized &&
        !this.props.firebase.auth &&
        this.props.firebase.auth === undefined
      ) {
        this.props.onSetUiFlag("operationType", "add");

        this.setState(prevState => {
          return {
            ...prevState
          };
        });
        this.props.firebase.doInitiate("BROOKLYNZ");
        this.setState(prevState => {
          return {
            ...prevState,
            notInitialized: false,
            phoneNumber:
              window.location.hostname === this.state.localhost
                ? this.state.phoneNumber
                : ""
          };
        });
        this.props.onSetUiFlag("notLoadedBasicData", true);
      }

      this.unregisterAuthObserver = this.props.firebase.auth.onAuthStateChanged(
        user => {
          //console.log("changed now");
          this.setState({ isSignedIn: !!user });
          if (user) {
            this.loadBasicData();
            this.stateChangeHandler("homepage", "stage", false);
          } else {
            //console.log("setting showgoog to true");
            this.stateChangeHandler(true, "showGoog", false);
          }
        }
      );
      //console.log("adding scroll listner");

      this.props.onSetUiFlag("loginProgress", false);
    } catch (err) {
      console.log(err);
    }
  }

  handleScroll = event => {
    if (this.props.currUserRole === "SUPERADMIN") {
      let scDiv = window.document.getElementById("oDiv");
      if (scDiv && scDiv !== undefined) {
        //console.log("scrolling... ");
        if (this.state.showGrid) {
          this.props.onSetUiFlag("listYPos", scDiv.scrollTop);
        }
      }
    }
  };

  componentDidCatch(error, info) {
    //handle the sending message to backend? store back to db? send notification?
    console.log("Uncaught : " + error + " | " + info);
    this.switchMenu("bcsHome");
  }

  setScroll = setToTop => {
    //console.log("attempting scroll");
    let element = window.document.querySelector("#oDiv");
    if (element && element !== "") {
      //console.log("setting scroll");
      if (setToTop) {
        //console.log("setting to 0");
        window.scrollTo(0, 0);
        element.scroll(0, 0);
      } else {
        //console.log("setting to " + this.props.listYPos);
        if (this.props.currUserRole === "SUPERADMIN") {
          element.scroll(0, parseInt(this.props.listYPos));
        }
      }
    } else {
      console.log("element not found");
    }
  };

  componentWillUnmount() {
    try {
      this.unregisterAuthObserver();
    } catch (err) {}
  }

  applyDataCondition = (singleRecord, dataCondition) => {
    let tmpRes = false;

    for (let p = 0; p < dataCondition.length; p++) {
      if (
        singleRecord[dataCondition[p]["colKey"]] ===
        dataCondition[p]["fieldVal"]
      ) {
        tmpRes = true;
      }

      if (
        singleRecord[dataCondition[p]["colKey"]] ===
        this.props.userProfile[dataCondition[p]["fieldVal"]]
      ) {
        tmpRes = true;
      }
    }
    //console.log("~~ returning: " + tmpRes);
    return tmpRes;
  };

  loadDataEx = allTableDets => {
    let recsLimit = 0;

    if (isMobile) {
      if (allTableDets.recMobileLimit) {
        recsLimit = parseInt(allTableDets.recMobileLimit);
      }
    } else {
      if (allTableDets.recMobileLimit) {
        recsLimit = parseInt(allTableDets.recLimit);
      }
    }

    let basePath = "/";
    let tableName = allTableDets.tableName;
    this.props.onSetUiFlag(tableName + "-downloaded", false);
    if (recsLimit > 0) {
      this.props.firebase.db
        .ref(basePath + tableName)
        .limitToLast(recsLimit)
        .on("value", snapshot => {
          let tmpArray = [];
          let fbOject = [];
          Promise.all([snapshot.val()]).then(res => {
            fbOject = res[0];
            if (fbOject && fbOject !== null && fbOject !== undefined) {
              Object.keys(fbOject).map(key => {
                let item = {
                  ...fbOject[key],
                  key: key
                };
                //console.log("~~ Linking " + JSON.stringify(allTableDets));
                if (
                  allTableDets.dataConditions &&
                  allTableDets.dataConditions !== undefined &&
                  allTableDets.dataConditions.length > 0
                ) {
                  //console.log(JSON.stringify(allTableDets.dataConditions));
                  if (
                    this.applyDataCondition(item, allTableDets.dataConditions)
                  ) {
                    tmpArray.push(item);
                  }
                } else {
                  tmpArray.push(item);
                }
              });
            }
            //reverse to have latest at the top
            tmpArray.reverse();
            this.props.onAddRecord({
              path: tableName,
              payload: tmpArray
            });
            this.props.onSetUiFlag(tableName + "-downloaded", true);
          });
        });
    } else {
      //console.log("here the load data");
      this.props.firebase.db.ref(basePath + tableName).on("value", snapshot => {
        let tmpArray = [];
        let fbOject = [];
        Promise.all([snapshot.val()]).then(res => {
          fbOject = res[0];
          if (fbOject && fbOject !== null && fbOject !== undefined) {
            Object.keys(fbOject).map(key => {
              let item = {
                ...fbOject[key],
                key: key
              };
              //console.log("~~ Linking " + JSON.stringify(allTableDets));
              if (
                allTableDets.dataConditions &&
                allTableDets.dataConditions !== undefined &&
                allTableDets.dataConditions.length > 0
              ) {
                //console.log(JSON.stringify(allTableDets.dataConditions));
                if (
                  this.applyDataCondition(item, allTableDets.dataConditions)
                ) {
                  tmpArray.push(item);
                }
              } else {
                tmpArray.push(item);
              }
            });
          }
          //reverse to have latest at the top
          //console.log("reversing " + tableName);
          tmpArray.reverse();
          this.props.onAddRecord({
            path: tableName,
            payload: tmpArray
          });
          this.props.onSetUiFlag(tableName + "-downloaded", true);
          let crTable = _.cloneDeep(this.props.createTable);
          let tDefs = getDefs(crTable);
          let extDefs = getExtendedOgDefs(crTable);
          this.setState(prevState => {
            return {
              ...prevState,
              tableDefs: tDefs,
              formDefs: extDefs
            };
          });
        });
      });
    }
    //}
  };

  loadData = (tableName, isDeleted) => {
    //console.log(tableName);
    let recsLimit = 3000;
    if (isMobile) {
      recsLimit = 2000;
    }
    if (tableName === "attendance") {
      if (isMobile) {
        recsLimit === 2000;
      } else {
        recsLimit === 3000;
      }
    }
    let basePath = "/";
    if (isDeleted) {
      basePath = "/deletedRecs/";
    }
    this.props.firebase.db
      .ref(basePath + tableName)
      .limitToLast(recsLimit)
      .on("value", snapshot => {
        ////console.log("Linking " + tableName);
        let tmpArray = [];
        let fbOject = [];
        let projTempArray = [];
        Promise.all([snapshot.val()]).then(res => {
          //basic updating keys into objects
          fbOject = res[0];
          if (fbOject && fbOject !== null && fbOject !== undefined) {
            tmpArray = Object.keys(fbOject).map(key => ({
              ...fbOject[key],
              key: key
            }));
          }
          //reverse to have latest at the top
          tmpArray.reverse();

          //filter project table for engineer and contributor
          if (
            tableName === "projects" &&
            (this.props.currUserRole === "ENGINEER" ||
              this.props.currUserRole === "CONTRIBUTOR")
          ) {
            projTempArray = tmpArray.filter(item => {
              return item.projectPhase === "IN FLIGHT";
            });

            //handle delete
            if (isDeleted) {
              this.props.onAddRecord({
                path: "deleted" + tableName,
                payload: projTempArray
              });
            } else {
              this.props.onAddRecord({
                path: tableName,
                payload: projTempArray
              });
            }
          } else {
            //handle delete
            if (isDeleted) {
              this.props.onAddRecord({
                path: "deleted" + tableName,
                payload: tmpArray
              });
            } else {
              this.props.onAddRecord({ path: tableName, payload: tmpArray });
            }
          }
        });
      });
  };

  getPrevOrderProds = () => {
    console.log("extracting list ");
    if (
      this.props.db["deliveryRequest"] &&
      this.props.db["deliveryRequest"].length > 0
    ) {
      let myOrders = this.props.db["deliveryRequest"].filter(
        ord => "+65" + ord.mobile === this.props.cellPhone
      );
      let myProds = [];
      for (let i = 0; i < myOrders.length; i++) {
        let singOrd = myOrders[i];
        for (let j = 0; j < singOrd.requestedItems.length; j++) {
          if (!myProds.includes(singOrd.requestedItems[j].key)) {
            let ordItem = singOrd.requestedItems[j];
            let foundItem = tSupplierShopItems.find(
              item => item.key === ordItem.key
            );
            myProds.push(foundItem);
          }
        }
      }
      //PREVIOUSLY ORDERED
      //console.log("extracting here are the: " + JSON.stringify(myProds));
      this.props.onAddArray({ path: "PREVIOUSLY ORDERED", payload: myProds });
      //return myProds;
    } else {
      //console.log("deliveryrequest is empty");
      return [];
    }
  };

  getFrequentlyOrder = () => {
    if (
      this.props.db["deliveryRequest"] &&
      this.props.db["deliveryRequest"].length > 0
    ) {
      let freqProds = {};
      console.log(this.props.db["deliveryRequest"].length);
      for (let i = 0; i < this.props.db["deliveryRequest"].length; i++) {
        let currOrd = this.props.db["deliveryRequest"][i];
        if (
          currOrd &&
          currOrd.requestedItems &&
          currOrd.requestedItems.length > 0
        ) {
          for (let j = 0; j < currOrd.requestedItems.length; j++) {
            let currItem = currOrd.requestedItems[j];
            if (freqProds[currItem.key]) {
              freqProds[currItem.key]["count"] =
                freqProds[currItem.key]["count"] + 1;
            } else {
              if (
                this.props.db["supplierShopItems"] &&
                this.props.db["supplierShopItems"].length > 0
              ) {
                let newObj = this.props.db["supplierShopItems"].find(
                  item => item.key === currItem.key
                );
                if (newObj && newObj !== undefined) {
                  freqProds[currItem.key] = _.cloneDeep(newObj);
                  freqProds[currItem.key]["count"] = 1;
                }
              }
            }
          }
        }
      }

      freqProds = _.sortBy(freqProds, "count");
      freqProds = freqProds.reverse();
      //let finObj = {};
      // for (let i = 0; i < freqProds.length; i++) {
      //   finObj[freqProds[i].key] = freqProds[i];
      // }
      console.log(JSON.stringify(freqProds));
      return freqProds;
      //this.stateChangeHandler(finalArray, "freqProds", false);
    } else {
      return [];
      //this.stateChangeHandler([], "freqProds", false);
    }
  };

  getMenuDiv = () => {
    if (
      this.props.currUserRole !== "SUPERADMIN" &&
      this.state.stage !== "login"
    ) {
      return (
        <div
          style={{
            position: "fixed",
            top: "0px",
            padding: "5px",
            left: "50vw",
            height: "100%",
            width: "50vw",
            minWidth: "180px",
            backgroundColor: "white",
            borderRadius: "3px",
            opacity: 1,
            zIndex: "25",
            border: "1px solid #E0E6E8",
            boxSizing: "border-box",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.5)",
            overflowY: "hidden",
            transition: "all 0.3s ease-in-out",
            transformOrigin: "right top",
            transform: this.state.showMenu ? null : "scaleX(0)"
          }}
        >
          <icon
            className="fa fa-close"
            style={{
              position: "fixed",
              top: "0",
              right: "0",
              margin: "5px",
              fontSize: "1.5em"
            }}
            onClick={() => {
              this.stateChangeHandler(!this.state.showMenu, "showMenu", false);
            }}
          />
          <ul
            className="nav navbar-nav navbar-left"
            style={{
              width: "100%"
            }}
          >
            {this.fetchMenus()}
          </ul>
        </div>
      );
    }
  };

  getFieldOptionsArray = (tableName, fieldName, addAll, doSort) => {
    let categList = [];
    if (this.props.createTable && this.props.createTable.length > 0) {
      let shopItems = this.props.createTable.find(
        item => item.name == tableName
      );

      if (shopItems) {
        let categField = shopItems.fields.find(item => item.name === fieldName);
        if (categField) {
          categList = _.cloneDeep(categField.staticSource);

          if (doSort) {
            categList = _.sortBy(categList, "name");
          }
        }
      }
    }
    return categList;
  };

  categIsSelected = categName => {
    //console.log(categName + " " + this.state.searchFilters.category);
    let isSelected = false;

    if (this.state.searchFilters.category === categName) {
      isSelected = true;
    }

    if (categName === "ALL" && !this.state.searchFilters.category) {
      isSelected = true;
    }
    return isSelected;
  };

  getCategTabs = () => {
    //console.log(JSON.stringify(this.props.createTable));

    let categList = this.getFieldOptionsArray(
      "supplierShopItems",
      "category",
      true,
      false
    );

    if (categList && categList.length > 0) {
      //console.log("got categ list: " + JSON.stringify(categList));
      return categList.map(item => {
        return (
          <div
            style={{
              height: this.categIsSelected(item.name) ? "37px" : "35px",
              margin: "1px",
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minWidth: "80px",
              fontSize: "10px",
              textAlign: "center",
              fontWeight: this.categIsSelected(item.name) ? "bold" : "normal",
              border: this.categIsSelected(item.name)
                ? "1px solid gainsboro"
                : null,
              borderBottom: this.categIsSelected(item.name)
                ? "2px solid grey"
                : "1px solid gainsboro",
              borderTopLeftRadius: "5px",
              borderTopRightRadius: "5px"
            }}
            onClick={() => {
              if (item.name === "ALL") {
                this.stateChangeHandler({}, "searchFilters", false);
              } else {
                this.stateChangeHandler(
                  { category: item.name },
                  "searchFilters",
                  false
                );
              }

              this.setScroll(true);
            }}
          >
            {item.name}
          </div>
        );
      });
    }
  };

  getOverLay = () => {
    if (this.props.currUserRole !== "SUPERADMIN" && this.state.showMenu) {
      return (
        <div
          style={{
            position: "fixed",
            display: "block",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.5)",
            zIndex: 9,
            cursor: "pointer"
          }}
          onClick={() => {
            this.stateChangeHandler(!this.state.showMenu, "showMenu", false);
          }}
        ></div>
      );
    }
  };

  getMenuButton = () => {
    /*
    show menu items when:
      shopFromASupplier
      openBazar
      homepage
    */
    if (
      this.props.currUserRole !== "SUPERADMIN" &&
      this.state.stage !== "login"
    ) {
      if (
        this.state.stage === "shopFromASupplier" ||
        this.state.stage === "openBazarList" ||
        this.state.stage === "openBazar" ||
        this.state.stage === "homepage" ||
        this.state.stage === "selectCategory" ||
        this.state.stage === "orderlist" ||
        this.state.stage === "supplier" ||
        this.state.stage === "directOrderpad" ||
        this.state.stage === "storeAdminElse" ||
        this.state.stage === "passportService" ||
        this.state.stage === "addToShop" ||
        this.state.stage === "hCommService" ||
        this.state.stage === "remitService" ||
        this.state.stage === "agraniService" ||
        this.state.stage === "primeService"
      ) {
        return (
          <div
            style={{
              padding: "5px",
              borderRadius: "5px",
              color: "rgb(30, 101, 144)",
              zIndex: "20"
            }}
            onClick={() =>
              this.stateChangeHandler(!this.state.showMenu, "showMenu", false)
            }
          >
            <icon
              className="fa fa-bars fa-2x"
              style={{
                marginLeft: "2px",
                marginRight: "2px",
                marginTop: "2px"
              }}
            />
          </div>
        );
      }
    }
  };

  getFilterButton = () => {
    /* 
    show filter only if it is NOT SUPERADMIN and stage is showFromASupplier
    
    */
    if (this.props.currUserRole !== "SUPERADMIN") {
      if (this.state.stage === "shopFromASupplier") {
        return (
          <div
            style={{
              position: "fixed",
              top: "10px",
              right: "50px",
              border: "1px solid grey",
              padding: "3px",
              borderRadius: "5px",
              border: "1px solid #E0E6E8",
              boxSizing: "border-box",
              boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              color: "rgb(30, 101, 144)",
              zIndex: "20"
            }}
            onClick={() => {
              this.setScroll(true);
              this.stateChangeHandler("selectCategory", "stage", false);
            }}
          >
            <icon
              className="fa fa-sliders fa-2x"
              style={{
                marginLeft: "2px",
                marginRight: "2px",
                marginTop: "2px"
              }}
            />
          </div>
        );
      }
    }
  };

  getAddButton = () => {
    //this should be addToShop view
    if (
      this.props.currUserRole === "STOREADMIN" &&
      (this.state.stage === "addToShop" ||
        this.state.stage === "storeAdminElse") &&
      this.state.showGrid
    ) {
      return (
        <div
          style={{
            padding: "5px",
            borderRadius: "5px",

            color: "rgb(30, 101, 144)",
            zIndex: "20"
          }}
          onClick={() => {
            this.handleAddNew("addToShop");
          }}
        >
          <icon
            className="fa fa-plus fa-2x"
            style={{
              marginLeft: "2px",
              marginRight: "2px",
              marginTop: "2px"
            }}
          />
        </div>
      );
    }
  };

  getCloseButton = () => {
    //this should be addToShop view
    if (
      this.props.operationType === "update" &&
      this.state.stage === "directOrderpad"
    ) {
      return (
        <div
          style={{
            padding: "5px",
            borderRadius: "5px",
            color: "rgb(30, 101, 144)",
            zIndex: "20"
          }}
          onClick={() => {
            this.backToList(
              "orderlist",
              "deliveryRequest",
              this.state.selectedSupplier
            );
            this.props.onAddArray({ path: "bucket", payload: [] });
          }}
        >
          <icon
            className="fa fa-close fa-2x"
            style={{
              marginLeft: "2px",
              marginRight: "2px",
              marginTop: "2px"
            }}
          />
        </div>
      );
    }
  };

  getHomeButton = () => {
    //this should be addToShop view
    if (
      this.state.stage === "openBazarList" ||
      this.state.stage === "orderlist" ||
      this.state.stage === "supplier" ||
      this.state.stage === "addToShop" ||
      this.state.stage === "directOrderpad" ||
      this.state.stage === "shopFromASupplier" ||
      this.state.stage === "passportService" ||
      this.state.stage === "storeAdminElse" ||
      this.state.stage === "hCommService" ||
      this.state.stage === "remitService" ||
      this.state.stage === "agraniService" ||
      this.state.stage === "primeService"
    ) {
      return (
        <div
          style={{
            padding: "5px",
            borderRadius: "5px",
            color: "rgb(30, 101, 144)",
            zIndex: "20"
          }}
          onClick={() => {
            this.setScroll(true);
            this.stateChangeHandler({}, "searchFilters", false);
            this.stateChangeHandler("homepage", "stage", false);
            this.stateChangeHandler("users", "tableName", false);
            this.stateChangeHandler(true, "showGrid", false);
          }}
        >
          <icon
            className="fa fa-home fa-2x"
            style={{
              marginLeft: "2px",
              marginRight: "2px",
              marginTop: "2px"
            }}
          />
        </div>
      );
    }
  };

  getSupplierButton = () => {
    //this should be addToShop view

    if (
      this.props.currUserRole === "STOREADMIN" &&
      this.state.stage === "homepage"
    ) {
      return (
        <div
          style={{
            padding: "5px",
            borderRadius: "5px",

            color: "rgb(30, 101, 144)",
            zIndex: "20"
          }}
          onClick={() => {
            this.setScroll(true);
            this.backToList("supplier", "deliveryRequest");
          }}
        >
          <icon
            className="fa fa-tachometer fa-2x"
            style={{
              marginLeft: "2px",
              marginRight: "2px",
              marginTop: "2px"
            }}
          />
        </div>
      );
    }
  };

  getNewOrderButton = () => {
    if (
      this.state.stage === "orderlist" &&
      this.state.tableName === "deliveryRequest"
    ) {
      return (
        <div
          style={{
            padding: "0.5em 0.5em",
            borderRadius: "8px",
            color: "#fff",
            backgroundColor: "rgb(30, 101, 144)",
            border: "0px",
            cursor: "pointer",
            marginLeft: "10px",
            marginTop: "5px",
            fontWeight: "bold",
            maxWidth: "140px"
          }}
          onClick={() => {
            //console.log("doing new order  ");
            this.backToList("shopFromASupplier", "supplierShopItems");
          }}
        >
          <span>
            <icon
              className="fa fa-shopping-bag"
              style={{
                color: "white",
                marginRight: "15px"
              }}
            />
          </span>
          NEW ORDER
        </div>
      );
    }
  };

  getAddMoreItemsButton = () => {
    if (
      this.state.stage === "directOrderpad" &&
      this.state.tableName === "supplierShopItems" &&
      this.props.orderStage === "showForm"
    ) {
      return (
        <div
          style={{
            padding: "0.5em 0.5em",
            borderRadius: "8px",
            color: "#fff",
            backgroundColor: "rgb(30, 101, 144)",
            border: "0px",
            cursor: "pointer",
            marginLef: "5px",
            fontWeight: "bold",
            maxWidth: "200px",
            marginLeft: "10px",
            marginTop: "5px"
          }}
          onClick={() => {
            //console.log("doing new order  ");
            this.backToList(
              "shopFromASupplier",
              "supplierShopItems",
              this.state.selectedSupplier
            );
            this.stateChangeHandler(true, "showGrid", false);
          }}
        >
          <span>
            <icon
              className="fa fa-shopping-bag"
              style={{
                color: "white",
                marginRight: "15px"
              }}
            />
          </span>
          ADD MORE
        </div>
      );
    }
  };

  getViewOrdersButton = () => {
    if (
      this.state.stage === "directOrderpad" &&
      this.state.tableName === "supplierShopItems" &&
      (this.props.orderStage === "showConfirmation" ||
        this.props.orderStage === "showUpdateConfirmation")
    ) {
      return (
        <div
          style={{
            padding: "0.5em 0.5em",
            borderRadius: "8px",
            color: "#fff",
            backgroundColor: "rgb(30, 101, 144)",
            border: "0px",
            cursor: "pointer",
            marginTop: "5px",
            marginLeft: "10px",
            fontWeight: "bold",
            maxWidth: "200px"
          }}
          onClick={() => {
            this.backToList(
              "orderlist",
              "deliveryRequest",
              this.state.selectedSupplier
            );
            this.stateChangeHandler({}, "searchFilters", false);
            this.stateChangeHandler(true, "showGrid", false);
            this.props.onAddArray({ path: "bucket", payload: [] });
          }}
        >
          <span>
            <icon
              className="fa fa-shopping-bag"
              style={{
                color: "white",
                marginRight: "15px"
              }}
            />
          </span>
          VIEW YOUR ORDERS
        </div>
      );
    }
  };

  getAddPostPlusButton = () => {
    //this should be addToShop view
    if (
      this.state.stage === "openBazarList" &&
      this.state.tableName === "openBazar"
    ) {
      return (
        <div
          style={{
            padding: "5px",
            borderRadius: "5px",

            color: "rgb(30, 101, 144)",
            zIndex: "20"
          }}
          onClick={() => {
            this.handleAddNew("openBazar");
          }}
        >
          <icon
            className="fa fa-plus fa-2x"
            style={{
              marginLeft: "2px",
              marginRight: "2px",
              marginTop: "2px"
            }}
          />
        </div>
      );
    }
  };

  // getAddPostButton = () => {
  //   if (
  //     this.state.stage === "openBazarList" &&
  //     this.state.tableName === "openBazar"
  //   ) {
  //     return (
  //       <div
  //         style={{
  //           padding: "0.5em 0.5em",
  //           borderRadius: "8px",
  //           color: "#fff",
  //           backgroundColor: "rgb(30, 101, 144)",
  //           fontSize: "1.1em",
  //           border: "0px",
  //           cursor: "pointer",
  //           margin: "5px",
  //           fontWeight: "bold",
  //           maxWidth: "140px"
  //         }}
  //         onClick={() => {
  //           this.handleAddNew("openBazar");
  //         }}
  //       >
  //         <span>
  //           <icon
  //             className="fa fa-comments"
  //             style={{
  //               color: "white",
  //               marginRight: "15px"
  //             }}
  //           />
  //         </span>
  //         ADD POST
  //       </div>
  //     );
  //   }
  // };

  fetchMenus = () => {
    // console.log("Fetching menus for " + this.props.currUserRole + "...");
    // console.log(
    //   "Props userMenu: " +
    //     JSON.stringify(this.props.userMenus) +
    //     " props worker menus: " +
    //     JSON.stringify(this.props.workerMenus)
    // );
    // console.log(
    //   "Props worker menus: " + JSON.stringify(this.props.workerMenus)
    // );
    if (this.props.currUserRole && this.props.userMenus) {
      let userMenus = this.getUserMenu(this.props.currUserRole);
      //console.log("userMenus: " + JSON.stringify(userMenus));
      return getMenuList(
        true,
        this.isAdmin(),
        this.switchMenu,
        this.props.currUserRole,
        userMenus && userMenus.length > 0 ? userMenus : this.props.workerMenus
      );
    }
  };

  getUserMenu = userRole => {
    let allMenusFromDb = this.props.menuDesigner;
    let allOtherMenus = [];
    if (allMenusFromDb && allMenusFromDb.length > 0) {
      let userMenu = allMenusFromDb.find(
        singMenu => singMenu.name === userRole
      );

      if (userMenu && userMenu !== undefined) {
        allOtherMenus = userMenu.menuItems.map(singleMenu => {
          let srcTable = this.props.listOfTables.find(
            item => item.name === singleMenu.tableName
          );
          if (srcTable && srcTable !== undefined && srcTable.name) {
            return {
              ...singleMenu,
              menuCaption: srcTable.menu
            };
          } else {
            console.log("table not found: " + singleMenu.tableName);
          }
        });
      }
    } else {
    }

    return allOtherMenus;
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  logoutApp = () => {
    let msgToApp = {
      actionType: "logOut",
      payload: {}
    };

    if (window && window.ReactNativeWebView) {
      //console.log("posing logout message to app");
      window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
    }
  };

  switchMenu = menuName => {
    console.log(menuName);
    this.stateChangeHandler(false, "showFilters");
    if (this.refs && this.refs.searchText) {
      this.refs.searchText.value = "";
      this.doDelaySearch();
    }

    this.props.onAddArray({
      path: "bucket",
      payload: []
    });

    this.stateChangeHandler("", "searchVal", false);
    this.stateChangeHandler({}, "searchDateFilters", false);
    this.stateChangeHandler(false, "showPivot", false);

    if (this.props.currUserRole === "SUPERADMIN") {
      if (menuName === "dashboard") {
        this.stateChangeHandler(true, "showDash", false);
        this.stateChangeHandler(false, "showGrid", false);
        this.stateChangeHandler(menuName, "tableName", false);
      } else if (menuName === "bcsHome") {
        this.stateChangeHandler("users", "tableName", false);
        this.stateChangeHandler("homepage", "stage", false);
        this.stateChangeHandler(true, "showGrid", false);
        this.stateChangeHandler(false, "showDash", false);
      } else if (menuName === "signout") {
        this.props.firebase.doSignOut();
        this.props.onSignOut();
        this.logoutApp();
        browserHistory.push("/login");
      } else {
        this.stateChangeHandler(true, "showGrid", false);
        this.stateChangeHandler(false, "showDash", false);
        this.stateChangeHandler(menuName, "tableName", false);
        this.setScroll(true);
      }
    } else {
      if (menuName === "signout") {
        //console.log("signing out");
        this.props.firebase.doSignOut();
        this.stateChangeHandler("startButtonText", "LOADING ...", false);
        this.props.onSignOut();
        this.logoutApp();
        this.stateChangeHandler("login", "stage", false);
        this.stateChangeHandler(false, "isSignIn", false);
        this.stateChangeHandler(false, "loginProgress", false);
        this.stateChangeHandler("deliveryRequest", "tableName", false);
      } else {
        //view orders
        if (menuName === "deliveryRequest") {
          this.setScroll(true);
          this.stateChangeHandler({}, "searchFilters", false);
          this.stateChangeHandler("orderlist", "stage", false);
          this.stateChangeHandler("deliveryRequest", "tableName", false);

          //supplier to pick orders
        } else if (menuName === "dqr") {
          this.setScroll(true);

          this.stateChangeHandler({}, "searchFilters", false);
          this.stateChangeHandler("supplier", "stage", false);
          this.stateChangeHandler(true, "showGrid", false);
          this.stateChangeHandler("deliveryRequest", "tableName", false);

          //open bazar
        } else if (menuName === "openBazar") {
          this.setScroll(true);
          this.stateChangeHandler({}, "searchFilters", false);
          this.stateChangeHandler("openBazarList", "stage", false);
          this.stateChangeHandler(true, "showGrid", false);
          this.stateChangeHandler("openBazar", "tableName", false);

          //for adding and updating products to shop
        } else if (menuName === "supplierShopItems") {
          this.setScroll(true);
          this.stateChangeHandler({}, "searchFilters", false);
          this.stateChangeHandler("addToShop", "stage", false);
          this.stateChangeHandler(true, "showGrid", false);
          this.stateChangeHandler("supplierShopItems", "tableName", false);

          //go back to home
        } else if (menuName === "bcsHome") {
          this.setScroll(true);
          this.stateChangeHandler({}, "searchFilters", false);
          this.stateChangeHandler("homepage", "stage", false);
          this.stateChangeHandler(true, "showGrid", false);
          this.stateChangeHandler("users", "tableName", false);
        } else {
          this.setScroll(true);
          this.stateChangeHandler({}, "searchFilters", false);
          this.stateChangeHandler("storeAdminElse", "stage", false);
          this.stateChangeHandler(true, "showGrid", false);
          this.stateChangeHandler(menuName, "tableName", false);
        }
      }
    }
    this.stateChangeHandler(!this.state.showMenu, "showMenu", false);
  };

  isAdmin = () => {
    return this.props.isAdmin || this.props.isSuperAdmin;
  };

  handleDelete = (key, path, searchObj) => {
    this.props.firebase.db.ref("/" + path + "/" + key).remove();
    this.stateChangeHandler(true, "showGrid", false);
  };

  handleOrderEdit = (key, path, fullPayload) => {
    console.log("path: " + path);
    if (fullPayload && fullPayload.status !== "DELIVERED") {
      this.setScroll(true);

      this.stateChangeHandler("supplierShopItems", "tableName", false);
      this.stateChangeHandler("directOrderpad", "stage", false);
      this.props.onAddArray({
        path: "bucket",
        payload: fullPayload.requestedItems
      });
      this.props.onSelectRecord({ path: path, key: key });
      this.props.onSetUiFlag("operationType", "update");
      this.props.onSetUiFlag("orderStage", "showForm");
      this.setScroll(true);
    }
  };

  handleBazarEdit = (key, path, fullPayload) => {
    if (fullPayload) {
      this.setScroll(true);
      this.stateChangeHandler("openBazar", "stage", false);
      this.props.onSelectRecord({ path: path, key: key });
      this.props.onSetUiFlag("operationType", "update");
      this.stateChangeHandler(false, "showGrid", false);
    }
  };

  handleMyShopEdit = (key, path, fullPayload) => {
    if (fullPayload) {
      //this.setScroll(true);
      //this.stateChangeHandler("addToShop", "stage", false);
      this.props.onSelectRecord({ path: path, key: key });
      this.props.onSetUiFlag("operationType", "update");
      //this.stateChangeHandler(false, "showGrid", false);
    }
  };

  handleAddNew = stageName => {
    //console.log("generating new: " + stageName);
    // let initData = getInitData(
    //   this.state.tableName,
    //   this.props.createTable,
    //   this.props.userProfile
    // );
    // if (initData && initData !== undefined) {
    //   this.stateChangeHandler(false, "showGrid", false);
    //   this.props.onSetUiFlag("operationType", "add");
    //   this.props.onSetUiFlag("tableName", this.state.tableName);
    //   this.props.onAddNew({
    //     path: this.state.tableName,
    //     data: { ...initData }
    //   });
    // }
    this.setScroll(true);
    let initData = getInitData(
      this.state.tableName,
      this.props.createTable,
      this.props.userProfile
    );

    if (initData && initData !== undefined) {
      window.document.querySelector("#oDiv").scroll(0, 0);
      this.stateChangeHandler(stageName, "stage", false);
      this.stateChangeHandler(false, "showGrid", false);
      this.props.onSetUiFlag("operationType", "add");
      this.props.onSetUiFlag("tableName", this.state.tableName);
      this.props.onAddNew({
        path: this.state.tableName,
        data: { ...initData }
      });
    } else {
      console.log("no init data");
      // console.log(
      //   "tableName: " +
      //     this.state.tableName +
      //     " crTable: " +
      //     JSON.stringify(this.props.createTable) +
      //     " " +
      //     JSON.stringify(initData)
      // );
    }
  };

  backToList = (listName, tableName, suppName) => {
    this.setScroll();
    this.stateChangeHandler(tableName, "tableName", false);
    this.stateChangeHandler(listName, "stage", false);
    this.stateChangeHandler("", "searchVal", false);
    if (suppName && suppName !== "") {
      this.stateChangeHandler(suppName, "selectedSupplier", false);
    }
    //this will be required to be made generic later
    if (tableName === "supplierShopItems") {
      this.stateChangeHandler("BCS SHOP", "selectedSupplier", false);
    }
  };

  getDashView = () => {
    return <div></div>;
  };

  getFields = () => {
    ////console.log("test");
    alert("test");
  };

  getData = customTable => {
    //console.log("doing get data");
    let dTableName = "users";
    if (!customTable) {
      dTableName = this.state.tableName;
    } else {
      dTableName = customTable;
    }

    if (dTableName !== "dashboard") {
      if (
        this.state.tableDefs[dTableName] &&
        this.state.tableDefs[dTableName] !== undefined &&
        this.state.refPhoneNumber &&
        this.state.refPhoneNumber !== ""
      ) {
        if (this.state.stage === "BuyFromSupplier") {
          return searchRecords(
            this.props.db["supplierShopItems"],
            this.state.searchVal,
            this.state.tableDefs["supplierShopItems"].searches
              ? this.state.tableDefs["supplierShopItems"].searches
              : [],
            this.state.searchFilters,
            this.state.searchDateFilters,
            this.state.refPhoneNumber,
            true
          );
        } else if (this.state.stage === "storeAdminElse") {
          //console.log("searching here....");
          let result = searchRecords(
            this.props.db[dTableName],
            this.state.searchVal,
            this.state.tableDefs[dTableName].searches
              ? this.state.tableDefs[dTableName].searches
              : [],
            this.state.searchFilters,
            this.state.searchDateFilters
          );
          //console.log("searched return " + result.length + " records");
          return result;
        } else {
          //console.log("searching here....");
          let result = searchRecords(
            this.props.db[dTableName],
            this.state.searchVal,
            this.state.tableDefs[dTableName].searches
              ? this.state.tableDefs[dTableName].searches
              : [],
            this.state.searchFilters,
            this.state.searchDateFilters,
            this.state.refPhoneNumber
          );
          //console.log("searched return " + result.length + " records");
          return result;
        }
      } else {
        //console.log("returning blank");
        return [];
      }
    }
  };

  getAdminData = () => {
    //console.log("looking for data: " + this.state.tableName);
    //console.log(JSON.stringify(this.state.searchFilters));
    let dTableName = this.state.tableName;

    if (dTableName !== "dashboard") {
      //console.log("not dash");
      if (
        this.state.searchVal === "" &&
        Object(this.state.searchFilters).keys &&
        Object(this.state.searchFilters).keys.length === 0
      ) {
        //console.log("time to return all data");
        let allData = this.props.db[dTableName];
        return allData;
      } else {
        //console.log("its with some filters");
        if (
          this.state.tableDefs[dTableName] &&
          this.state.tableDefs[dTableName] !== undefined
        ) {
          //console.log("it has some tableDefs");
          let allFullData = searchRecords(
            this.props.db[dTableName],
            this.state.searchVal,
            this.state.tableDefs[dTableName].searches,
            this.state.searchFilters,
            this.state.searchDateFilters
          );
          //console.log(JSON.stringify(allFullData));
          return allFullData;
        } else {
          //console.log("didnt search");
        }
      }
    } else {
      //console.log("its dash");
    }
  };

  doStateUpdateForSearch = () => {
    this.setState(
      prevState => {
        return {
          ...prevState,
          searchVal: this.refs.searchText.value,
          searchFilters: {}
        };
      },
      () => {
        this.setScroll(true);
      }
    );
  };

  doDelaySearch = () => {
    ////console.log("doning search...");
    const q = this.refs.searchText.value;
    //this.stateChangeHandler("searchVal", q, false);

    if (q.length < 5) {
      this.getDataThrottled();
    } else {
      this.getDataDebounced();
    }
  };

  getSearchBar = () => {
    /*
    show only if it is not superadmin
    1. shopFromASupplier
    2. supplier
    3. ??openBazar
    4. addToShop

    */
    if (this.props.currUserRole !== "SUPERADMIN" && this.state.showGrid) {
      if (
        this.state.stage === "shopFromASupplier" ||
        this.state.stage === "supplier" ||
        this.state.stage === "openBazarList" ||
        this.state.stage === "addToShop"
      ) {
        return (
          <div>
            <div>
              <input
                type="text"
                placeholder="Search..."
                ref="searchText"
                onKeyUp={() => this.doDelaySearch()}
                style={{
                  height: "30px",
                  borderRadius: "5px",
                  width: "100%",
                  border: "0px",
                  padding: "5px",
                  margin: "5px",
                  border: "1px solid gainsboro"
                }}
              />
            </div>
            {/* <div
          style={{
            margin: "5px",
            marginLeft: "0px",
            width: "80%"
          }}
        >
          {this.getFilterDropDowns()}
        </div> */}
          </div>
        );
      }
    }
  };

  getFiltersList = () => {
    let filtersList = [];
    if (this.props.createTable && this.props.createTable.length > 0) {
      let tableObj = this.props.createTable.find(
        item => item.name === this.state.tableName
      );

      if (tableObj && tableObj !== undefined) {
        if (tableObj.filters && tableObj.filters !== undefined) {
          filtersList = tableObj.filters;
        }
      }

      return filtersList;
    } else {
      return [];
    }
  };

  getFilterDropDowns = () => {
    if (this.state.showGrid || true) {
      return (
        <div>
          <GridFilters
            path={this.state.tableName}
            stateHandler={this.stateChangeHandler}
            value={this.state.searchFilters}
            ogTableDef={this.state.formDefs}
            filtersList={this.getFiltersList()}
          />
          <GridDateFilters
            path={this.state.tableName}
            stateHandler={this.stateChangeHandler}
            value={this.state.searchDateFilters}
            ogTableDef={this.state.formDefs}
            filtersList={this.getFiltersList()}
          />
        </div>
      );
    }
  };

  getAllSuppliers = () => {
    let allSup = _.chain(this.props.users)
      .filter(item => item.roleName === "STOREADMIN")
      .pluck("userMobile")
      .filter(item => item !== "" && item !== null && typeof item === "string")
      .value();
    return allSup;
  };

  getGrid = () => {
    if (
      this.props.currUserRole === "WORKER" ||
      this.props.currUserRole === "STOREADMIN"
    ) {
      if (this.state.stage === "orderlist") {
        //console.log("getting worker grid");
        return (
          <div
            style={{
              overflow: "auto"
            }}
          >
            <WorkerGrid
              data={this.getData()}
              tableName={this.state.tableName}
              tableDef={this.state.tableDefs[this.state.tableName]}
              handleEdit={this.handleOrderEdit}
              handleDelete={this.handleDelete}
              backToList={this.backToList}
              dataIsLoaded={this.props.ui[this.state.tableName + "-downloaded"]}
              role={"worker"}
              phoneNumber={this.props.firebase.auth.currentUser.phoneNumber}
              firebase={this.props.firebase}
              updateRecord={this.props.onUpdateRecord}
              onNotifyUsers={this.props.onNotifyUsers}
              allSuppliers={this.getAllSuppliers()}
              stage={this.state.stage}
              repeatOrder={this.repeatOrder}
            />
          </div>
        );
      }

      if (this.state.stage === "addToShop") {
        //console.log("sending MyShopGrid back");

        return (
          <MyShopGrid
            data={this.getAdminData()}
            tableName={this.state.tableName}
            tableDef={this.state.tableDefs[this.state.tableName]}
            handleEdit={this.handleMyShopEdit}
            handleDelete={this.handleDelete}
            genDirectSupplierOrder={this.genDirectSupplierOrder}
            addToBucket={this.addToBucket}
            removeFromBucket={this.removeFromBucket}
            getBucketDetails={this.getBucketDetails}
            supplierName={
              this.props.userProfile && this.props.userProfile["userCompany"]
                ? this.props.userProfile["userCompany"]
                : ""
            }
            supplierRole={
              this.props.userProfile && this.props.userProfile["roleName"]
                ? this.props.userProfile["roleName"]
                : ""
            }
            role="all"
            handleEditCancel={() => {
              this.backToList("addToShop", "supplierShopItems");
              this.stateChangeHandler(true, "showGrid");
            }}
            handleDelete={this.handleDelete}
            ogTableDef={getExtendedOgDefs(this.props.createTable)}
            genNotification={this.genNotification}
            refPhoneNumber={this.state.refPhoneNumber}
          />
        );
      }

      if (this.state.stage === "openBazarList") {
        //console.log("open bazar grid");
        return (
          <OpenBazarGrid
            data={this.getData()}
            tableName={this.state.tableName}
            tableDef={this.state.tableDefs[this.state.tableName]}
            handleEdit={this.handleBazarEdit}
            handleDelete={this.handleDelete}
            handleAddNew={this.handleAddNew}
            role={"worker"}
            phoneNumber={this.props.firebase.auth.currentUser.phoneNumber}
            dataIsLoaded={this.props.ui[this.state.tableName + "-downloaded"]}
            firebase={this.props.firebase}
            updateRecord={this.props.onUpdateRecord}
            onNotifyUsers={this.props.onNotifyUsers}
          />
        );
      }
      if (this.state.stage === "supplier") {
        //console.log("sending back adming grid for supplier");
        return (
          <AdminGrid
            data={
              this.props.db["deliveryRequest"] &&
              this.props.db["deliveryRequest"].length > 0
                ? this.props.db["deliveryRequest"].slice(0, 250)
                : []
            }
            tableName={this.state.tableName}
            firebase={this.props.firebase}
            updateRecord={this.props.onUpdateRecord}
            onNotifyUsers={this.props.onNotifyUsers}
            tableDef={this.state.tableDefs[this.state.tableName]}
            handleEdit={this.handleEdit}
            handleDelete={this.handleDelete}
            supplierName={
              this.props.userProfile && this.props.userProfile["userCompany"]
                ? this.props.userProfile["userCompany"]
                : ""
            }
            supplierRole={
              this.props.userProfile && this.props.userProfile["roleName"]
                ? this.props.userProfile["roleName"]
                : ""
            }
            role="grocer"
            dataIsLoaded={this.props.ui[this.state.tableName + "-downloaded"]}
            searchVal={this.state.searchVal}
            allSuppliers={this.getAllSuppliers()}
            fetchDistance={this.props.onFetchDistance}
            updateRedux={this.props.onAddArray}
            cellPhone={this.props.cellPhone}
          />
        );
      }
      if (this.state.stage === "storeAdminElse") {
        console.log("returing vanilla grid");
        return (
          <ContentGridVanilla
            data={this.getData()}
            tableName={this.state.tableName}
            tableDef={this.state.tableDefs[this.state.tableName]}
            handleEdit={this.handleEdit}
            handleDelete={this.handleDelete}
          />
        );
      }
    }
  };

  getTopMenu = () => {
    //console.log("getting super admin menus");
    return (
      <nav className="navbar navbar-default navbar-fixed-top">
        <div className="container-fluid">
          <div className="navbar-header">
            {this.state.stage !== "login" && (
              <button
                type="button"
                className="pull-left navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#navMenu"
                aria-expanded="false"
                style={{
                  marginLeft: "10px"
                }}
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>
            )}
            <a
              className="navbar-brand"
              href="#"
              style={{
                marginLeft: "-10px",
                color: "black",
                marginRight: "-10px",
                width: "120px",
                fontSize: "14px",
                padding: "0px",
                lineHeight: "50px"
              }}
            >
              {getCaption(this.state.tableName, this.props.listOfTables)}
            </a>

            {this.state.stage !== "login" &&
              this.state.stage !== "orderpad" &&
              this.state.showGrid &&
              !this.state.showDash && (
                <button
                  type="button"
                  className="pull-right navbar-toggle"
                  style={{
                    marginLeft: "0px",
                    marginRight: "10px",
                    marginTop: "10px",
                    paddingRight: "13px",
                    paddingLeft: "13px",
                    paddingTop: "5px",
                    paddingBottom: "5px"
                  }}
                >
                  <span
                    class="fa fa-filter fa-lg"
                    aria-hidden="true"
                    onClick={() => {
                      this.setState(prevState => {
                        return {
                          ...prevState,
                          showFilters: !prevState.showFilters
                        };
                      });
                    }}
                  ></span>
                </button>
              )}
            {this.state.stage !== "login" &&
              this.state.showGrid &&
              (this.props.userProfile.roleName === "SUPERADMIN" ||
                this.state.tableName === "supplierShopItems" ||
                this.state.tableName === "openBazar") && (
                <button
                  type="button"
                  className="pull-right navbar-toggle"
                  style={{
                    marginLeft: "0px",
                    marginRight: "10px",
                    marginTop: "10px",
                    paddingRight: "13px",
                    paddingLeft: "13px",
                    paddingTop: "5px",
                    paddingBottom: "5px"
                  }}
                >
                  <span
                    class="fa fa-plus fa-lg"
                    aria-hidden="true"
                    onClick={() => {
                      if (this.props.currUserRole === "SUPERADMIN") {
                        this.handleAddNew(this.state.tableName);
                        this.stateChangeHandler(false, "showGrid", false);
                      } else {
                        if (this.state.stage === "openBazarList") {
                          this.handleAddNew("openBazar");
                        } else if (this.state.stage === "shopFromASupplier") {
                          this.handleAddNew("addToShop");
                        } else {
                          this.handleAddNew(this.state.stage);
                        }
                      }
                    }}
                  ></span>
                </button>
              )}
          </div>
          {this.state.stage !== "login" &&
            !this.state.showDash &&
            this.state.showFilters && (
              <div
                style={{
                  marginTop: "15px",
                  marginBottom: "15px"
                }}
              >
                {this.state.showGrid &&
                  this.state.showFilters &&
                  this.getSearchBar()}
              </div>
            )}
          <div className="collapse navbar-collapse" id="navMenu">
            <ul className="nav navbar-nav navbar-left">{this.fetchMenus()}</ul>
          </div>
        </div>
      </nav>
    );
  };

  getAdminGrid = () => {
    console.log("getting admin grid");
    if (this.props.currUserRole === "SUPERADMIN") {
      return (
        <ContentGridVanilla
          data={this.getAdminData()}
          tableName={this.state.tableName}
          tableDef={this.state.tableDefs[this.state.tableName]}
          handleEdit={this.handleEdit}
          handleDelete={this.handleDelete}
        />
      );
    }
  };

  deliverOrderByStoreAdmin = (key, fullPayload) => {
    let rec = _.cloneDeep(fullPayload);

    let cloudPath = "deliveryRequest";

    if (rec && rec.key && rec.key !== "") {
      rec.status = "DELIVERED";
      cloudPath = cloudPath + "/" + rec.key;

      this.props.firebase.db
        .ref("/" + cloudPath)
        .once("value")
        .then(snap => {
          return snap.ref.set(rec);
        })
        .catch(err => {
          console.log(err);
          return console.log("some error: " + err);
        })
        .then(err => {
          alert("Order successfully updated as DELIVERED.");
          let phArray = [];
          phArray.push(rec.mobile);
          this.props.onNotifyUsers(
            "Your order was marked as delivered. If you have not received your items, please wait for a while. If you have already received your items, you can help us by rating the service.",
            phArray
          );
        });
    } else {
      console.log("did not save");
    }
  };

  getInputField = (fieldName, poDefs) => {
    return getInputField(
      fieldName,
      "projectPos",
      this.state.data,
      this.stateChangeHandler,
      false,
      poDefs,
      this.props.db,
      isMobile
    );
  };

  getNewBazarListButton = () => {
    if (this.state.showGrid) {
      return (
        <div
          style={{
            padding: "0.6em 2em",
            borderRadius: "8px",
            color: "#fff",
            backgroundColor: "rgb(30, 101, 144)",
            fontSize: "1.1em",
            border: "0px",
            cursor: "pointer",
            margin: "1em",
            fontWeight: "bold"
          }}
          onClick={() => {
            () => this.handleAddNew("openBazar");
          }}
        >
          POST MESSAGE IN BAZAR
        </div>
      );
    }
  };

  getBazarHeader = () => {
    return (
      <div
        style={{
          padding: "5px",
          position: "absolute",
          zIndex: "1",
          marginTop: "60px",
          marginBottom: "40px",
          width: "100%",
          top: 0,
          left: 0
        }}
      >
        <div>{this.getSearchBar()}</div>
        <table
          className={
            isMobile
              ? "table table-striped table-sm"
              : "table table-striped table-lg"
          }
        >
          <tbody>
            <td
              style={{
                textAlign: "center",
                padding: "5px"
              }}
            >
              {this.getNewBazarListButton()}
            </td>
          </tbody>
        </table>
      </div>
    );
  };
  getShopListHeader = () => {
    return (
      <div
        style={{
          padding: "5px",
          position: "absolute",
          zIndex: "1",
          marginTop: "60px",
          marginBottom: "40px",
          width: "100%",
          top: 0,
          left: 0
        }}
      >
        <div>{this.getSearchBar()}</div>
      </div>
    );
  };

  getPromoHeader = () => {
    return (
      <div
        style={{
          padding: "5px",
          position: "absolute",
          zIndex: "1",
          marginTop: "60px",
          marginBottom: "40px",
          width: "100%",
          top: 0,
          left: 0
        }}
      >
        <div>{this.getSearchBar()}</div>
      </div>
    );
  };

  getDirectShopHeader = () => {
    return (
      <div
        style={{
          padding: "5px",
          position: "absolute",
          zIndex: "1",
          marginTop: "60px",
          marginBottom: "40px",
          width: "100%",
          top: 0,
          left: 0
        }}
      >
        <div>{this.getSearchBar()}</div>
        <table
          className={
            isMobile
              ? "table table-striped table-sm"
              : "table table-striped table-lg"
          }
        >
          <tbody>
            <td
              style={{
                textAlign: "center",
                padding: "5px"
              }}
            >
              {this.getNewShopOrderButton()}
            </td>
          </tbody>
        </table>
      </div>
    );
  };

  storeAutoLoginToApp = phoneNumber => {
    let elemEmail = document.getElementById("email");
    let elemPass = document.getElementById("password");
    let tmpEmail = "";
    let tmpPass = "";
    if (elemEmail && elemEmail.value !== "") {
      tmpEmail = elemEmail.value;
    }

    if (elemPass && elemPass.value !== "") {
      tmpPass = elemPass.value;
    }
    let msgToApp = {
      actionType: "storeAutoLogin",
      payload: {
        email: tmpEmail,
        password: tmpPass,
        company: phoneNumber
      }
    };

    if (window && window.ReactNativeWebView) {
      //console.log("posing autologin message to app");
      window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
    }
  };

  getUiForAuth = () => {
    if (
      !this.state.notInitialized &&
      this.props.firebase &&
      this.props.firebase.phoneAuthProvider.PROVIDER_ID
    ) {
      //console.log("heaven");
      return (
        <FirebaseAuth
          uiConfig={{
            // Popup signin flow rather than redirect flow.
            signInFlow: "popup",
            // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
            signInSuccessUrl: "/workers",
            callbacks: {
              signInSuccess: () => {
                console.log("something something");
                return false;
              },
              signInSuccessWithAuthResult: () => false
            },
            // We will display Google and Facebook as auth providers.

            signInOptions: [
              {
                provider: this.props.firebase.phoneAuthProvider.PROVIDER_ID,
                recaptchaParameters: {
                  type: "image", // 'audio'
                  // size: "compact", // 'invisible' or 'compact'
                  badge: "bottomleft" //' bottomright' or 'inline' applies to invisible.
                },
                defaultCountry: "SG", // Set default country to the United Kingdom (+44).
                // For prefilling the national number, set defaultNationNumber.
                // This will only be observed if only phone Auth provider is used since
                // for multiple providers, the NASCAR screen will always render first
                // with a 'sign in with phone number' button.
                defaultNationalNumber: "",
                // You can also pass the full phone number string instead of the
                // 'defaultCountry' and 'defaultNationalNumber'. However, in this case,
                // the first country ID that matches the country code will be used to
                // populate the country selector. So for countries that share the same
                // country code, the selected country may not be the expected one.
                // In that case, pass the 'defaultCountry' instead to ensure the exact
                // country is selected. The 'defaultCountry' and 'defaultNationaNumber'
                // will always have higher priority than 'loginHint' which will be ignored
                // in their favor. In this case, the default country will be 'GB' even
                // though 'loginHint' specified the country code as '+1'.
                loginHint: ""
              }
            ]
          }}
          firebaseAuth={this.props.firebase.auth}
        />
      );
    } else {
      //console.log("hell");
    }
  };

  getHiddenControls = () => {
    return (
      <div>
        {window.location.hostname !== this.state.localhost && (
          <input
            type="hidden"
            className="form-control"
            id="company"
            ref="company"
          />
        )}

        {window.location.hostname === this.state.localhost && (
          <input
            type="hidden"
            className="form-control"
            id="company"
            ref="company"
            value={localState.phoneNumber}
          />
        )}

        <input
          className="form-control"
          id="appVersion"
          ref="appVersion"
          type="hidden"
        />

        <input className="form-control" id="email" ref="email" type="hidden" />

        <input
          className="form-control"
          id="password"
          secure
          ref="password"
          type="hidden"
          disabled={this.state.loginProgress}
        />
      </div>
    );
  };

  getLoginPage = () => {
    if (this.state.showGoog) {
      return (
        <div
          style={{
            marginTop: "60px"
          }}
        >
          <div
            style={{
              border: "0px solid grey",
              borderRadius: "5px",
              padding: "5px"
            }}
          >
            <div
              style={{
                marginTop: "3px",
                marginBottom: "3px"
              }}
            >
              {this.getUiForAuth()}
            </div>
            {!this.state.isSignedIn &&
              this.state.stage === "login" &&
              getMarketingBox()}
            <div
              style={{
                marginTop: "3px",
                marginBottom: "3px",
                textAlign: "center",
                margin: "10px"
              }}
            ></div>
          </div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            margin: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh"
          }}
        >
          <img
            src={logoB64Text}
            style={{
              height: "100px",
              width: "100px",
              borderRadius: "100px",
              animation: "rotation 2s infinite linear",
              perspective: "1000px"
            }}
          />
        </div>
      );
    }
  };

  loadBasicData = () => {
    if (
      this.props.notLoadedBasicData &&
      this.props.firebase &&
      this.props.firebase.auth &&
      this.props.firebase.auth.currentUser
    ) {
      let strTokDets = JSON.stringify(this.props.firebase.auth.currentUser);
      let objTokDets = JSON.parse(strTokDets);
      //console.log("s1 loading data ");
      let refPhoneNumber = this.props.firebase.auth.currentUser.phoneNumber;
      if (!refPhoneNumber || refPhoneNumber === null || refPhoneNumber === "") {
        this.switchMenu("signout");
        return;
      }
      refPhoneNumber = refPhoneNumber.replace("+65", "");
      let accessToken = undefined;

      // LogRocket.identify(refPhoneNumber, {
      //   name: refPhoneNumber,
      //   email: refPhoneNumber,
      //   // Add your own custom user variables here, ie:
      //   subscriptionType: "pro"
      // });
      this.storeAutoLoginToApp(refPhoneNumber);
      this.props.onSetUiFlag(
        "cellPhone",
        this.props.firebase.auth.currentUser.phoneNumber
      );
      this.stateChangeHandler(refPhoneNumber, "refPhoneNumber", "");
      if (
        refPhoneNumber !== null &&
        refPhoneNumber !== undefined &&
        refPhoneNumber !== ""
      ) {
        this.props.onReachApiExtended({
          fetchQuery:
            "https://bau0t6mjj6.execute-api.us-east-1.amazonaws.com/default/getAgrani",
          method: "GET",
          message: null,
          path: "agraniRates",
          headers: {}
        });

        this.props.onReachApiExtended({
          fetchQuery:
            "https://m70fg43zh9.execute-api.us-east-1.amazonaws.com/default/getPrime",
          method: "GET",
          message: null,
          path: "primeRates",
          headers: {}
        });
        this.props
          .loadFbData(
            "myPassDetails",
            this.props.firebase,
            false,
            "myPassDetails/" + refPhoneNumber,
            true
          )
          .then(listRes => {
            //console.log(moment().format("x") + " basic orders done");
          });
        accessToken = objTokDets.stsTokenManager.accessToken;

        //passport applictions related stff
        this.props
          .loadFbData(
            "myPassApps",
            this.props.firebase,
            false,
            "myPassApps/+65" + refPhoneNumber
          )
          .then(listRes => {
            //console.log(moment().format("x") + " basic orders done");
          });
        if (accessToken) {
          this.props.onInitialFetch(
            "hCommApps",
            this.props.firebase.dbUrl + "/hCommApps.json",
            accessToken
          );
        }
        //update first secretary's number here
        if (refPhoneNumber === "94562455") {
          this.props
            .loadFbData("hCommApps", this.props.firebase, false, "hCommApps")
            .then(listRes => {
              //console.log(moment().format("x") + " basic orders done");
            });
        }

        //remittance applications related stuff
        this.props
          .loadFbData(
            "myRemitApps",
            this.props.firebase,
            false,
            "remSvc/+65" + refPhoneNumber + "/remApps"
          )
          .then(listRes => {
            //console.log(moment().format("x") + " basic orders done");
          });
        this.props
          .loadFbData(
            "myRemitRegs",
            this.props.firebase,
            false,
            "remSvc/+65" + refPhoneNumber + "/remRegs"
          )
          .then(listRes => {
            //console.log(moment().format("x") + " basic orders done");
          });
        /************************** */
        //agranionly
        if (accessToken) {
          this.props.onInitialFetch(
            "agraniApps",
            this.props.firebase.dbUrl + "/agraniApps.json",
            accessToken
          );
        }
        //update agrani's numbers here
        if (refPhoneNumber === "94562455") {
          this.props
            .loadFbData("agraniApps", this.props.firebase, false, "agraniApps")
            .then(listRes => {
              //console.log(moment().format("x") + " basic orders done");
            });
        }

        if (accessToken) {
          this.props.onInitialFetch(
            "agraniRegs",
            this.props.firebase.dbUrl + "/agraniRegs.json",
            accessToken
          );
        }
        //update agrani's numbers here
        if (refPhoneNumber === "94562455") {
          this.props
            .loadFbData("agraniRegs", this.props.firebase, false, "agraniRegs")
            .then(listRes => {
              //console.log(moment().format("x") + " basic orders done");
            });
        }
        /************************** */

        //PRIME STUFF
        /************************** */
        //primeonly
        if (accessToken) {
          this.props.onInitialFetch(
            "primeApps",
            this.props.firebase.dbUrl + "/primeApps.json",
            accessToken
          );
        }
        //update agrani's numbers here
        if (refPhoneNumber === "94562455") {
          this.props
            .loadFbData("primeApps", this.props.firebase, false, "primeApps")
            .then(listRes => {
              //console.log(moment().format("x") + " basic orders done");
            });
        }

        if (accessToken) {
          this.props.onInitialFetch(
            "primeRegs",
            this.props.firebase.dbUrl + "/primeRegs.json",
            accessToken
          );
        }
        //update agrani's numbers here
        if (refPhoneNumber === "94562455") {
          this.props
            .loadFbData("primeRegs", this.props.firebase, false, "primeRegs")
            .then(listRes => {
              //console.log(moment().format("x") + " basic orders done");
            });
        }
        /************************** */
        // this.props.onInitialProductsFetch(
        //   this.props.firebase.dbUrl + "/supplierShopItems.json",
        //   accessToken
        // );

        // this.props.onInitialFetch(
        //   "POPULAR",
        //   this.props.firebase.dbUrl + "/POPULAR.json",
        //   accessToken
        // );

        /*
        listOfTables: tListOfTables,
  createTable: tCreateTable,
  menuDesigner: tMenuDesigner,
  */

        // if (accessToken) {
        //   this.props.onInitialFetch(
        //     "listOfTables",
        //     this.props.firebase.dbUrl + "/listOfTables.json",
        //     accessToken
        //   );
        // }
        // if (accessToken) {
        //   this.props.onInitialFetch(
        //     "createTable",
        //     this.props.firebase.dbUrl + "/createTable.json",
        //     accessToken
        //   );
        // }
        // if (accessToken) {
        //   this.props.onInitialFetch(
        //     "menuDesigner",
        //     this.props.firebase.dbUrl + "/menuDesigner.json",
        //     accessToken
        //   );
        // }

        // if (accessToken) {
        //   this.props.onInitialFetch(
        //     "users",
        //     this.props.firebase.dbUrl + "/users.json",
        //     accessToken
        //   );
        // }

        // this.props
        //   .loadFbData("supplierShopItems", this.props.firebase, false)
        //   .then(listrest => {
        //     //console.log(moment().format("x") + " basic products done");
        //   });

        this.props
          .loadFbData("openBazar", this.props.firebase, false)
          .then(listrest => {
            //console.log(moment().format("x") + " basic products done");
          });

        let otherRole = "";
        let tgtUser = undefined;
        if (this.props.users && this.props.users.length > 0) {
          //console.log(JSON.stringify(this.props.users));
          tgtUser = this.props.users.find(uItem => {
            if (
              uItem.userMobile &&
              uItem.userMobile !== "" &&
              uItem.userMobile.includes(refPhoneNumber)
            ) {
              //console.log(uItem.userName + " " + uItem.userMobile + " is true");
              return true;
            } else {
              return false;
            }
          });
        }
        if (
          tgtUser &&
          tgtUser !== undefined &&
          tgtUser.roleName &&
          tgtUser.roleName !== ""
        ) {
          //console.log("user is found: " + tgtUser.roleName);
          otherRole = tgtUser.roleName;
          this.props.onAddRecord({
            path: "userProfile",
            payload: tgtUser
          });
        } else {
          let usrStrLength =
            this.props.users && this.props.users.length > 0
              ? this.props.users.length
              : "0";
          //console.log("user is not found. " + usrStrLength);
        }

        if (otherRole === "") {
          otherRole = "WORKER";
          if (accessToken) {
            this.props.onInitialFetch(
              "deliveryRequest",
              this.props.firebase.dbUrl +
                "/myOrders/" +
                refPhoneNumber +
                ".json",
              accessToken
            );
          }
          this.props
            .loadFbData(
              "deliveryRequest",
              this.props.firebase,
              false,
              "myOrders/" + refPhoneNumber
            )
            .then(listRes => {
              //console.log(moment().format("x") + " basic orders done");
            });
        } else {
          if (accessToken) {
            this.props.onInitialFetch(
              "deliveryRequest",
              this.props.firebase.dbUrl + "/deliveryRequest.json",
              accessToken
            );
          }

          //load orders
          //console.log(moment().format("x") + " loading orders");
          this.props
            .loadFbData("deliveryRequest", this.props.firebase, false)
            .then(listRes => {
              //console.log(moment().format("x") + " basic orders done");
            });

          this.props
            .loadFbData("purchase", this.props.firebase, false)
            .then(listRes => {
              //console.log("deliveryRequest done");
            });
        }

        this.props.onSetUiFlag("currUserRole", otherRole);
        this.props.onSetUiFlag("loginProgress", false);
        this.switchMenu("bcsHome");
        this.stateChangeHandler(false, "showMenu", false);
      }
    } else {
      console.log("waiting for auth");
    }
  };

  doLogin = (nextAction, enterAsWorker) => {
    // console.log(
    //   "nextAction: " + nextAction + " enterAsWorker: " + enterAsWorker
    // );
    this.stateChangeHandler(enterAsWorker, "enterAsWorker", false);
    if (this.props.currUserRole === "WORKER") {
      //this user is a worker
      //console.log("entering as non admin now");
      if (!enterAsWorker && nextAction === "admin") {
        alert(
          "You are not registered as a supplier. Please contact Kabir Hossain at +65 94562455 to sign-up as a supplier."
        );
        this.stateChangeHandler("users", "tableName", false);
      } else {
        if (nextAction === "orderpad") {
          this.handleAddNew(nextAction);
        } else {
          this.stateChangeHandler(nextAction, "stage", false);
        }
      }
    } else {
      if (!enterAsWorker) {
        console.log("yes this is non worker account");
        this.stateChangeHandler(nextAction, "stage", false);
      } else {
        //menu problem
        if (nextAction === "orderpad") {
          this.handleAddNew(nextAction);
        } else {
          this.stateChangeHandler(nextAction, "stage", false);
        }
      }
    }
  };

  getBg = actor => {
    var now = moment();
    var numb = now.seconds();
    //console.log("numb: " + numb);
    let bgImage = null;
    if (actor.bgImage === "bcsshop") {
      bgImage = bcsShopImage;
    } else {
      bgImage = bcsOpenBazarImage;
    }
    if (actor.bgImage === "bcsshop") {
      return (
        <video
          loop={true}
          autoPlay="autoplay"
          muted
          preload="yes"
          playsinline="playsinline"
          poster={bgImage}
          style={{
            overflow: "hidden",
            width: "100%",
            height: "100%",
            objectFit: "cover",
            top: 0,
            left: 0,
            borderRadius: "5px",
            position: "absolute",
            zIndex: "-1"
          }}
          id={"vidTest"}
        >
          {/* {numb <= 6 && (
            <source
              src={require("file-loader!./vids/cook.webm")}
              type="video/webm"
            />
          )}
          {numb <= 6 && (
            <source
              src={require("file-loader!./vids/cook.mp4")}
              type="video/mp4"
            />
          )}
          {numb <= 12 && (
            <source
              src={require("file-loader!./vids/chillis.webm")}
              type="video/webm"
            />
          )}
          {numb <= 12 && (
            <source
              src={require("file-loader!./vids/chillis.mp4")}
              type="video/mp4"
            />
          )}
          {numb <= 18 && (
            <source
              src={require("file-loader!./vids/cook.webm")}
              type="video/webm"
            />
          )}
          {numb <= 18 && (
            <source
              src={require("file-loader!./vids/cook.mp4")}
              type="video/mp4"
            />
          )}
          {numb <= 24 && (
            <source
              src={require("file-loader!./vids/fruits.webm")}
              type="video/webm"
            />
          )}
          {numb <= 24 && (
            <source
              src={require("file-loader!./vids/fruits.mp4")}
              type="video/mp4"
            />
          )}
          {numb <= 30 && (
            <source
              src={require("file-loader!./vids/london.webm")}
              type="video/webm"
            />
          )}
          {numb <= 30 && (
            <source
              src={require("file-loader!./vids/london.mp4")}
              type="video/mp4"
            />
          )}
          {numb <= 36 && (
            <source
              src={require("file-loader!./vids/cook.webm")}
              type="video/webm"
            />
          )}
          {numb <= 36 && (
            <source
              src={require("file-loader!./vids/cook.mp4")}
              type="video/mp4"
            />
          )}
          {numb <= 48 && (
            <source
              src={require("file-loader!./vids/tomatos.webm")}
              type="video/webm"
            />
          )}
          {numb <= 48 && (
            <source
              src={require("file-loader!./vids/tomatos.mp4")}
              type="video/mp4"
            />
          )}
          {numb > 48 && (
            <source
              src={require("file-loader!./vids/phone.webm")}
              type="video/webm"
            />
          )}
          {numb > 48 && (
            <source
              src={require("file-loader!./vids/phone.mp4")}
              type="video/mp4"
            />
          )} */}
        </video>
      );
    } else {
      return (
        <video
          loop={true}
          autoPlay="autoplay"
          playbackRate={"0.5"}
          id="vid"
          muted
          playsinline="playsinline"
          poster={bgImage}
          style={{
            overflow: "hidden",
            width: "100%",
            height: "100%",
            objectFit: "cover",
            top: 0,
            left: 0,
            position: "absolute",
            borderRadius: "5px",
            zIndex: "-1"
          }}
          id={"vidTest"}
        >
          {/* <source
            src={require("file-loader!./vids/openBazar.webm")}
            type="video/webm"
          />
          <source
            src={require("file-loader!./vids/openBazar.mp4")}
            type="video/mp4"
          /> */}
        </video>
      );
    }
  };

  //Pexels Video by Jessica Politi from Pexels

  getMediaEntry = actor => {
    let forceWorker = actor.forceWorker === "YES";
    /*
    
    */

    // let imgLoader = new Image();

    // imgLoader.src = actor.bgImage;
    // imgLoader.onload = () => {
    //   this.props.onSetUiFlag(actor.key, false);
    // };
    // if (this.props.ui[actor.key]) {
    // } else {
    return (
      <div
        style={{
          textAlign: "center",
          maxWidth: "600px",
          minHeight: "200px",
          margin: "auto",
          borderRadius: "10px",
          border: "1px solid #E0E6E8",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          margin: "5px",
          overflow: "hidden",
          position: "relative",
          marginBottom: "20px",
          display: "flex"
        }}
        onClick={() => {
          this.stateChangeHandler(actor.action1, "stage", false);

          //fix this later to make it parametrized
          if (actor.action1 === "shopFromASupplier") {
            this.stateChangeHandler(
              { category: "POPULAR" },
              "searchFilters",
              false
            );
          } else {
            this.stateChangeHandler({}, "searchFilters", false);
          }

          this.stateChangeHandler(actor.tableName, "tableName", false);
          this.stateChangeHandler(actor.userCompany, "selectedSupplier", false);
          this.stateChangeHandler(forceWorker, "enterAsWorker", false);
          this.setScroll(true);
        }}
      >
        {this.getBg(actor)}

        <div
          style={{
            margin: "auto",
            textAlign: "center",
            width: "100%",
            bottom: "0"
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              position: "absolute",
              top: "0",
              right: "0",
              backgroundColor: "rgb(30, 101, 144)",
              borderRadius: "60px",
              margin: "5px",
              padding: "0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1.4px solid white"
            }}
          >
            <span
              className="blink"
              style={{
                color: "white",
                fontSize: "12px",
                lineHeight: "12px",
                WebkitTextStroke: "1px white"
              }}
            >
              {actor.compIntoText}
            </span>
          </div>

          <div
            style={{
              textAlign: "center",
              margin: "auto",
              marginTop: "0px",
              color: "white"
            }}
          >
            <div
              style={{
                marginBottom: "-5px"
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadow:
                    "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
                }}
              >
                {actor.promoHeader}
              </span>
            </div>
            <div
              style={{
                color: "white",
                fontSize: "18px",
                textShadow:
                  "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
              }}
            >
              <span>{actor.promoDescription}</span>
            </div>
          </div>
        </div>
      </div>
    );
    //}
  };

  getRemitCard = () => {
    return (
      <div
        style={{
          textAlign: "center",
          maxWidth: "600px",
          minHeight: "200px",
          margin: "auto",
          borderRadius: "10px",
          border: "1px solid #E0E6E8",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          margin: "5px",
          overflow: "hidden",
          position: "relative",
          marginBottom: "20px",
          display: "flex",
          backgroundImage: "url(" + bcsPassportSvcImage + ")",
          backgroundSize: "cover"
        }}
        onClick={() => {
          this.setScroll(true);
          this.stateChangeHandler("remitService", "stage", false);
          // this.props.onReachApiExtended({
          //   fetchQuery:
          //     "https://bau0t6mjj6.execute-api.us-east-1.amazonaws.com/default/getAgrani",
          //   method: "GET",
          //   message: null,
          //   path: "agraniRates",
          //   headers: {}
          // });

          // this.props.onReachApiExtended({
          //   fetchQuery:
          //     "https://m70fg43zh9.execute-api.us-east-1.amazonaws.com/default/getPrime",
          //   method: "GET",
          //   message: null,
          //   path: "primeRates",
          //   headers: {}
          // });
        }}
      >
        <div
          style={{
            margin: "auto",
            textAlign: "center",
            width: "100%",
            bottom: "0"
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              position: "absolute",
              top: "0",
              right: "0",
              backgroundColor: "rgb(30, 101, 144)",
              borderRadius: "60px",
              margin: "5px",
              padding: "0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1.4px solid white"
            }}
          >
            <span
              className="blink"
              style={{
                color: "white",
                fontSize: "12px",
                lineHeight: "12px",
                WebkitTextStroke: "1px white"
              }}
            >
              ENTER
            </span>
          </div>

          <div
            style={{
              textAlign: "center",
              margin: "auto",
              marginTop: "5px",
              color: "white"
            }}
          >
            <div
              style={{
                marginBottom: "-5px"
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadow:
                    "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
                }}
              >
                SEND MONEY TO HOME
              </span>
            </div>
            <div
              style={{
                color: "white",
                fontSize: "18px",
                textShadow:
                  "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
              }}
            >
              <span>
                এখন থেকে মোবাইল ফোনেই মাত্র দুই মিনিটে পাসপোর্ট নবায়নের আবেদন
                করা যাবে।
              </span>
            </div>
            <div
              style={{
                color: "white",
                textShadow:
                  "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
              }}
            >
              <span>হেল্প লাগলে এই নাম্বারে 94562455 ফোন করুন</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  getAgraniCard = () => {
    return (
      <div
        style={{
          textAlign: "center",
          maxWidth: "600px",
          minHeight: "200px",
          margin: "auto",
          borderRadius: "10px",
          border: "1px solid #E0E6E8",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          margin: "5px",
          overflow: "hidden",
          position: "relative",
          marginBottom: "20px",
          display: "flex",
          backgroundImage: "url(" + bcsPassportSvcImage + ")",
          backgroundSize: "cover"
        }}
        onClick={() => {
          this.setScroll(true);
          this.stateChangeHandler("agraniService", "stage", false);
        }}
      >
        <div
          style={{
            margin: "auto",
            textAlign: "center",
            width: "100%",
            bottom: "0"
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              position: "absolute",
              top: "0",
              right: "0",
              backgroundColor: "rgb(30, 101, 144)",
              borderRadius: "60px",
              margin: "5px",
              padding: "0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1.4px solid white"
            }}
          >
            <span
              className="blink"
              style={{
                color: "white",
                fontSize: "12px",
                lineHeight: "12px",
                WebkitTextStroke: "1px white"
              }}
            >
              ENTER
            </span>
          </div>

          <div
            style={{
              textAlign: "center",
              margin: "auto",
              marginTop: "5px",
              color: "white"
            }}
          >
            <div
              style={{
                marginBottom: "-5px"
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadow:
                    "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
                }}
              >
                AGRANI ADMIN CENTER
              </span>
            </div>
            <div
              style={{
                color: "white",
                fontSize: "18px",
                textShadow:
                  "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
              }}
            >
              <span>
                এখন থেকে মোবাইল ফোনেই মাত্র দুই মিনিটে পাসপোর্ট নবায়নের আবেদন
                করা যাবে।
              </span>
            </div>
            <div
              style={{
                color: "white",
                textShadow:
                  "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
              }}
            >
              <span>হেল্প লাগলে এই নাম্বারে 94562455 ফোন করুন</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  getPrimeCard = () => {
    return (
      <div
        style={{
          textAlign: "center",
          maxWidth: "600px",
          minHeight: "200px",
          margin: "auto",
          borderRadius: "10px",
          border: "1px solid #E0E6E8",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          margin: "5px",
          overflow: "hidden",
          position: "relative",
          marginBottom: "20px",
          display: "flex",
          backgroundImage: "url(" + bcsPassportSvcImage + ")",
          backgroundSize: "cover"
        }}
        onClick={() => {
          this.setScroll(true);
          this.stateChangeHandler("primeService", "stage", false);
        }}
      >
        <div
          style={{
            margin: "auto",
            textAlign: "center",
            width: "100%",
            bottom: "0"
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              position: "absolute",
              top: "0",
              right: "0",
              backgroundColor: "rgb(30, 101, 144)",
              borderRadius: "60px",
              margin: "5px",
              padding: "0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1.4px solid white"
            }}
          >
            <span
              className="blink"
              style={{
                color: "white",
                fontSize: "12px",
                lineHeight: "12px",
                WebkitTextStroke: "1px white"
              }}
            >
              ENTER
            </span>
          </div>

          <div
            style={{
              textAlign: "center",
              margin: "auto",
              marginTop: "5px",
              color: "white"
            }}
          >
            <div
              style={{
                marginBottom: "-5px"
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadow:
                    "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
                }}
              >
                SEND MONEY VIA PRIME EXCHANGE
              </span>
            </div>
            <div
              style={{
                color: "white",
                fontSize: "18px",
                textShadow:
                  "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
              }}
            >
              <span></span>
            </div>
            <div
              style={{
                color: "white",
                textShadow:
                  "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
              }}
            >
              <span></span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  getPassportCard = () => {
    return (
      <div
        style={{
          textAlign: "center",
          maxWidth: "600px",
          minHeight: "200px",
          margin: "auto",
          borderRadius: "10px",
          border: "1px solid #E0E6E8",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          margin: "5px",
          overflow: "hidden",
          position: "relative",
          marginBottom: "20px",
          display: "flex",
          backgroundImage: "url(" + bcsPassportSvcImage + ")",
          backgroundSize: "cover"
        }}
        onClick={() => {
          this.setScroll(true);
          this.stateChangeHandler("passportService", "stage", false);
        }}
      >
        <div
          style={{
            margin: "auto",
            textAlign: "center",
            width: "100%",
            bottom: "0"
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              position: "absolute",
              top: "0",
              right: "0",
              backgroundColor: "rgb(30, 101, 144)",
              borderRadius: "60px",
              margin: "5px",
              padding: "0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1.4px solid white"
            }}
          >
            <span
              className="blink"
              style={{
                color: "white",
                fontSize: "12px",
                lineHeight: "12px",
                WebkitTextStroke: "1px white"
              }}
            >
              ENTER
            </span>
          </div>

          <div
            style={{
              textAlign: "center",
              margin: "auto",
              marginTop: "5px",
              color: "white"
            }}
          >
            <div
              style={{
                marginBottom: "-5px"
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadow:
                    "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
                }}
              >
                PASSPORT RENEWAL SERVICE
              </span>
            </div>
            <div
              style={{
                color: "white",
                fontSize: "18px",
                textShadow:
                  "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
              }}
            >
              <span>
                এখন থেকে মোবাইল ফোনেই মাত্র দুই মিনিটে পাসপোর্ট নবায়নের আবেদন
                করা যাবে।
              </span>
            </div>
            <div
              style={{
                color: "white",
                textShadow:
                  "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
              }}
            >
              <span>হেল্প লাগলে এই নাম্বারে 94562455 ফোন করুন</span>
            </div>
          </div>
        </div>
      </div>
    );
    //}
  };

  getHCommCard = () => {
    return (
      <div
        style={{
          textAlign: "center",
          maxWidth: "600px",
          minHeight: "200px",
          margin: "auto",
          borderRadius: "10px",
          border: "1px solid #E0E6E8",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          margin: "5px",
          overflow: "hidden",
          position: "relative",
          marginBottom: "20px",
          display: "flex",
          backgroundImage: "url(" + hcommImage + ")",
          backgroundSize: "cover"
        }}
        onClick={() => {
          this.setScroll(true);
          this.stateChangeHandler("hCommService", "stage", false);
        }}
      >
        <div
          style={{
            margin: "auto",
            textAlign: "center",
            width: "100%",
            bottom: "0"
          }}
        >
          <div
            style={{
              width: "45px",
              height: "45px",
              position: "absolute",
              top: "0",
              right: "0",
              backgroundColor: "rgb(30, 101, 144)",
              borderRadius: "60px",
              margin: "5px",
              padding: "0px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              border: "1.4px solid white"
            }}
          >
            <span
              className="blink"
              style={{
                color: "white",
                fontSize: "12px",
                lineHeight: "12px",
                WebkitTextStroke: "1px white"
              }}
            >
              ENTER
            </span>
          </div>

          <div
            style={{
              textAlign: "center",
              margin: "auto",
              marginTop: "5px",
              color: "white"
            }}
          >
            <div
              style={{
                marginBottom: "-5px"
              }}
            >
              <span
                style={{
                  fontSize: "26px",
                  fontWeight: "bold",
                  textTransform: "uppercase",
                  textShadow:
                    "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
                }}
              >
                BANGLADESH HIGH COMMISSION
              </span>
            </div>
            <div
              style={{
                color: "white",
                fontSize: "18px",
                textShadow:
                  "-1px -1px 0 #000,  1px -1px 0 #000,-1px  1px 0 #000,1px  1px 0 #000"
              }}
            >
              <span>View & Update Applications</span>
            </div>
          </div>
        </div>
      </div>
    );
    //}
  };

  getSupplierTile = user => {
    return (
      <div
        style={{
          textAlign: "center",
          width: "100%",
          marginTop: "15px",
          marginBottom: "20px"
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "5px",
            maxWidth: "600px",
            margin: "auto",
            borderRadius: "10px",
            backgroundColor: "white",
            border: "1px solid #E0E6E8",
            boxSizing: "border-box",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
          }}
        >
          <div
            style={{
              marginLeft: "5px",
              marginRight: "5px",
              textAlign: "left"
            }}
          >
            <h2
              style={{
                marginTop: "5px",
                fontSize: "22px",
                fontWeight: "bold",
                textTransform: "uppercase"
              }}
            >
              {user.userCompany}
            </h2>
            <div
              style={{
                marginBottom: "10px",
                marginTop: "-5px"
              }}
            >
              <div>
                <span
                  style={{
                    margin: "3px"
                  }}
                >
                  <icon class="fa fa-user" />
                </span>
                <span> {user.userName}</span>
              </div>
              <div>
                <span
                  style={{
                    margin: "3px"
                  }}
                >
                  <icon class="fa fa-phone" />
                </span>
                <span> {user.userMobile}</span>
              </div>
            </div>

            <div
              style={{
                marginBottom: "10px",
                marginTop: "-5px"
              }}
            >
              {user.compIntoText}
            </div>
          </div>
          <div>
            <div>
              <div
                style={{
                  padding: "0.6em 2em",
                  borderRadius: "8px",
                  color: "#fff",
                  backgroundColor: "rgb(30, 101, 144)",
                  fontSize: "1.1em",
                  border: "0px",
                  cursor: "pointer",
                  margin: "1em",
                  fontWeight: "bold"
                }}
                onClick={() => {
                  this.stateChangeHandler("shopFromASupplier", "stage", false);
                  this.stateChangeHandler(
                    user.userCompany,
                    "selectedSupplier",
                    false
                  );
                  this.stateChangeHandler(
                    "supplierShopItems",
                    "tableName",
                    false
                  );
                  this.stateChangeHandler(true, "enterAsWorker", false);
                  this.setScroll(true);
                }}
              >
                CHECK OUT THIS SHOP
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  getPromoPageList = () => {
    let allActors = this.props.users;
    if (allActors && allActors.length > 0) {
      let data = allActors.filter(
        actor =>
          actor.recordType === "STORE USER" ||
          actor.recordType === "PROMOTIONAL"
      );
      let tgtActors = _.chain(data)
        .sortBy("sortOrder")
        .value();
      return tgtActors.map(actor => {
        if (actor.recordType === "PROMOTIONAL") {
          return this.getMediaEntry(actor);
        }
      });
    }
  };

  getPublicNotice = () => {
    return (
      <div
        style={{
          textAlign: "center",
          minHeight: "200px",
          height: "215px",
          margin: "auto",
          borderRadius: "10px",
          border: "1px solid #E0E6E8",
          boxSizing: "border-box",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          margin: "5px",
          overflow: "hidden",
          position: "relative",
          marginBottom: "20px",
          backgroundColor: "white",
          padding: "5px"
        }}
      >
        <div
          style={{
            padding: "1px",
            textAlign: "right",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor: "white",
            zIndex: "-9"
          }}
        >
          <TextField
            value={this.state["notifyText"]}
            onChange={e => {
              this.stateChangeHandler(e.value, "notifyText", false);
            }}
            fullWidth
            placeholder="ENTER NOTIFICATION TEXT"
            multiline
            multilineRows={{ min: 7 }}
          />
        </div>
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <div
            style={{
              color: "#333",
              fontSize: "14px",
              backgroundColor: "rgb(30, 101, 144)",
              padding: "5px",
              borderRadius: "5px",
              color: "white",
              width: "30%",
              margin: "5px",
              textAlign: "center"
            }}
          >
            <div
              onClick={() => {
                this.stateChangeHandler("", "notifyText", false);
              }}
            >
              CLEAR
            </div>
          </div>
          <div
            style={{
              color: "#333",
              fontSize: "14px",
              backgroundColor: "red",
              padding: "5px",
              borderRadius: "5px",
              color: "white",
              width: "30%",
              margin: "5px",
              textAlign: "center"
            }}
          >
            <div
              onClick={() => {
                let resConfirm = confirm(
                  "Please confirm if you would like send this text as notifications to all users?\n \n \n " +
                    this.state.notifyText
                );

                if (resConfirm) {
                  this.props.onNotifyUsers(this.state.notifyText, [], true);
                }
              }}
            >
              NOTIFY USERS
            </div>
          </div>
        </div>
      </div>
    );
  };

  getHomePage = () => {
    //console.log("getting home page");
    if (this.state.isSignedIn && this.state.stage === "homepage") {
      if (this.state.testing) {
        return (
          <div>
            <div>
              <RemitService
                firebase={this.props.firebase}
                myRemitRegs={this.props.db["myRemitRegs"]}
                myRemitApps={this.props.db["myRemitApps"]}
                onSendEmail={this.props.onSendEmail}
                onNotifyUsers={this.props.onNotifyUsers}
                cellPhone={this.props.cellPhone}
                setScroll={this.setScroll}
              />
            </div>
          </div>
        );
      } else {
        return (
          <div
            style={{
              marginTop: "5px",
              marginBottom: "10px",
              textAlign: "left",
              marginTop: "60px"
            }}
          >
            <div
              style={{
                marginTop: "30px",
                textAlign: "center",
                overflowY: scroll,
                WebkitOverflowScrolling: "touch"
              }}
            >
              {this.getPromoPageList()}
              {this.getPassportCard()}
              {this.props.cellPhone === "+6594562455" && this.getPrimeCard()}
              {this.props.cellPhone === "+6594562455" && this.getHCommCard()}
              
              {/* {window.location.hostname === "localhost" &&
                this.props.cellPhone === "+6594562455" &&
                this.getHCommCard()}
              {window.location.hostname === "localhost" && this.getRemitCard()}
              {window.location.hostname === "localhost" &&
                this.props.cellPhone === "+6594562455" &&
                this.getAgraniCard()} */}

              {/* {this.props.cellPhone === "+6594562455" && (
              <div
                style={{
                  textAlign: "center",
                  minHeight: "215px",
                  margin: "auto",
                  borderRadius: "10px",
                  border: "1px solid #E0E6E8",
                  boxSizing: "border-box",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  margin: "5px",
                  overflow: "hidden",
                  position: "relative",
                  marginBottom: "20px",
                  backgroundColor: "white",
                  padding: "5px"
                }}
                onClick={() => {
                  this.setScroll(true);
                  this.stateChangeHandler("passportService", "stage", false);
                }}
              >
                <div>Bangledesh Passport Renewal Tests</div>
                <div>Pease take clear photo of info page of BGD passport</div>
              </div>
            )} */}

              <div
                style={{
                  textAlign: "center",
                  minHeight: "200px",
                  height: "215px",
                  margin: "auto",
                  borderRadius: "10px",
                  border: "1px solid #E0E6E8",
                  boxSizing: "border-box",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  margin: "5px",
                  overflow: "hidden",
                  position: "relative",
                  marginBottom: "20px"
                }}
              >
                <YouTube
                  videoId={"4CaMWXB3o2Y"}
                  opts={{
                    height: "215px",
                    width: "100%",
                    playerVars: {
                      // https://developers.google.com/youtube/player_parameters
                      autoPlay: 0,
                      controls: 1,
                      loop: 1,
                      modestbranding: 1,
                      rel: 0,
                      showinfo: 0
                    }
                  }}
                  onReady={this._onReady}
                />
              </div>

              <div
                style={{
                  textAlign: "center",
                  minHeight: "200px",
                  height: "215px",
                  margin: "auto",
                  borderRadius: "10px",
                  border: "1px solid #E0E6E8",
                  boxSizing: "border-box",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  margin: "5px",
                  overflow: "hidden",
                  position: "relative",
                  marginBottom: "20px"
                }}
              >
                <YouTube
                  videoId={"fYHkNEd7RQo"}
                  opts={{
                    height: "215px",
                    width: "100%",
                    playerVars: {
                      // https://developers.google.com/youtube/player_parameters
                      autoPlay: 0,
                      controls: 1,
                      loop: 1,
                      modestbranding: 1,
                      rel: 0,
                      showinfo: 0
                    }
                  }}
                  onReady={this._onReady}
                />
              </div>

              <div
                style={{
                  textAlign: "center",
                  minHeight: "200px",
                  height: "215px",
                  margin: "auto",
                  borderRadius: "10px",
                  border: "1px solid #E0E6E8",
                  boxSizing: "border-box",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  margin: "5px",
                  overflow: "hidden",
                  position: "relative",
                  marginBottom: "20px"
                }}
              >
                <YouTube
                  videoId={"zch9yd3bHi0"}
                  opts={{
                    height: "215px",
                    width: "100%",
                    playerVars: {
                      // https://developers.google.com/youtube/player_parameters
                      autoPlay: 0,
                      controls: 1,
                      loop: 1,
                      modestbranding: 1,
                      rel: 0,
                      showinfo: 0
                    }
                  }}
                  onReady={this._onReady}
                />
              </div>

              <div
                style={{
                  textAlign: "center",
                  minHeight: "200px",
                  height: "215px",
                  margin: "auto",
                  borderRadius: "10px",
                  border: "1px solid #E0E6E8",
                  boxSizing: "border-box",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  margin: "5px",
                  overflow: "hidden",
                  position: "relative",
                  marginBottom: "20px"
                }}
              >
                <YouTube
                  videoId={"AtXTsVHLTSU"}
                  opts={{
                    height: "215px",
                    width: "100%",
                    playerVars: {
                      // https://developers.google.com/youtube/player_parameters
                      autoPlay: 0,
                      controls: 1,
                      loop: 1,
                      modestbranding: 1,
                      rel: 0,
                      showinfo: 0
                    }
                  }}
                  onReady={this._onReady}
                />
              </div>

              <div
                style={{
                  textAlign: "center",
                  minHeight: "200px",
                  height: "215px",
                  margin: "auto",
                  borderRadius: "10px",
                  border: "1px solid #E0E6E8",
                  boxSizing: "border-box",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  margin: "5px",
                  overflow: "hidden",
                  position: "relative",
                  marginBottom: "20px"
                }}
              >
                <YouTube
                  videoId={"kL2JVvNxMVk"}
                  opts={{
                    height: "215px",
                    width: "100%",
                    playerVars: {
                      // https://developers.google.com/youtube/player_parameters
                      autoPlay: 0,
                      controls: 1,
                      loop: 1,
                      modestbranding: 1,
                      rel: 0,
                      showinfo: 0
                    }
                  }}
                  onReady={this._onReady}
                />
              </div>

              <div
                style={{
                  textAlign: "center",
                  minHeight: "200px",
                  height: "215px",
                  margin: "auto",
                  borderRadius: "10px",
                  border: "1px solid #E0E6E8",
                  boxSizing: "border-box",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
                  margin: "5px",
                  overflow: "hidden",
                  position: "relative",
                  marginBottom: "20px"
                }}
              >
                <YouTube
                  videoId={"p4bksA3-YpM"}
                  opts={{
                    height: "215px",
                    width: "100%",
                    playerVars: {
                      // https://developers.google.com/youtube/player_parameters
                      autoPlay: 0,
                      controls: 1,
                      loop: 1,
                      modestbranding: 1,
                      rel: 0,
                      showinfo: 0
                    }
                  }}
                  onReady={this._onReady}
                />
              </div>

              {this.props.cellPhone === "+6594562455" && this.getPublicNotice()}

              {/* {this.props.cellPhone === "+6594562455" &&
              getTopCustomers(this.props.db["deliveryRequest"])} */}
              <div
                style={{
                  margin: "5px",
                  border: "1px solid #ceb5b5",
                  overflow: "hidden",
                  borderRadius: "10px",
                  boxSizing: "border-box",
                  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
                }}
              >
                <div
                  style={{
                    height: "45px",
                    marginBottom: "5px",
                    color: "black",
                    lineHeight: "45px",
                    borderBottom: "1px solid #ceb5b5",
                    marginBottom: "12px",
                    fontSize: "14px"
                  }}
                >
                  YOUR PREVIOUS ORDERS
                </div>
                <div
                  style={{
                    textAlign: "left"
                  }}
                >
                  <WorkerGrid
                    data={this.getData("deliveryRequest")}
                    tableName={"deliveryRequest"}
                    tableDef={this.state.tableDefs["deliveryRequest"]}
                    handleEdit={this.handleOrderEdit}
                    handleDelete={this.handleDelete}
                    backToList={this.backToList}
                    dataIsLoaded={
                      this.props.ui["deliveryRequest" + "-downloaded"]
                    }
                    role={"worker"}
                    phoneNumber={
                      this.props.firebase.auth.currentUser.phoneNumber
                    }
                    firebase={this.props.firebase}
                    updateRecord={this.props.onUpdateRecord}
                    onNotifyUsers={this.props.onNotifyUsers}
                    allSuppliers={this.getAllSuppliers()}
                    stage={this.state.stage}
                    repeatOrder={this.repeatOrder}
                  />
                </div>
              </div>

              {this.props.currUserRole !== "SUPERADMIN" && (
                <div>
                  <div
                    style={{
                      textAlign: "center",
                      padding: "5px",
                      maxWidth: "600px",
                      marginTop: "15px",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      border: "1px solid #E0E6E8",
                      boxSizing: "border-box",
                      boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
                    }}
                  >
                    <div
                      style={{
                        marginLeft: "5px",
                        marginRight: "5px",
                        textAlign: "left"
                      }}
                    >
                      <div style={{ textAlign: "left" }}>{termsMainPage()}</div>
                    </div>
                  </div>
                  <div
                    style={{
                      margin: "20px",
                      textAlign: "center",
                      fontSize: "10px"
                    }}
                  >
                    v1.0.18
                  </div>
                  {(this.props.cellPhone === "+6594562455" ||
                    this.props.cellPhone === "+6597861234" ||
                    this.props.cellPhone === "+6594562456") && (
                    <div
                      onClick={() => {
                        window.confirm(
                          "Are you sure you want to refactor products?"
                        ) && this.updatePopular();
                      }}
                      style={{
                        height: "45px",
                        margin: "5px",
                        color: "white",
                        backgroundColor: "black",
                        lineHeight: "45px"
                      }}
                    >
                      Update Popular Prodcuts
                    </div>
                  )}

                  {(this.props.cellPhone === "+6594562455" ||
                    this.props.cellPhone === "+6597861234" ||
                    this.props.cellPhone === "+6594562456") && (
                    <div
                      onClick={() => {
                        window.confirm(
                          "Are you sure you want to refactor products?"
                        ) && this.getAllProductsArray();
                      }}
                      style={{
                        height: "45px",
                        margin: "5px",
                        color: "white",
                        backgroundColor: "black",
                        lineHeight: "45px"
                      }}
                    >
                      Generate all products array
                    </div>
                  )}

                  {(this.props.cellPhone === "+6594562455" ||
                    this.props.cellPhone === "+6597861234" ||
                    this.props.cellPhone === "+6594562456") && (
                    <div
                      onClick={() => {
                        window.confirm(
                          "Are you sure you want to update customer Orders?"
                        ) && this.generateMyOrders();
                      }}
                      style={{
                        height: "45px",
                        margin: "5px",
                        color: "white",
                        backgroundColor: "black",
                        lineHeight: "45px"
                      }}
                    >
                      Updated Customer Orders
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        );
      }
    }
  };

  getAllProductsArray = async () => {
    let strTokDets = JSON.stringify(this.props.firebase.auth.currentUser);
    let objTokDets = JSON.parse(strTokDets);
    let accessToken = objTokDets.stsTokenManager.accessToken;
    await this.props.onInitialProductsFetch(
      this.props.firebase.dbUrl + "/supplierShopItems.json",
      accessToken
    );
    //this.sleep(5000);
    //console.log(JSON.stringify(this.props.db["supplierShopItems"]));
  };

  getTotal = currBucket => {
    //console.log("calcing total again: " + JSON.stringify(currBucket));
    if (
      currBucket &&
      currBucket.length > 0 &&
      currBucket !== "" &&
      typeof currBucket === "object"
    ) {
      try {
        let totAmt = currBucket.reduce((sum, item) => {
          sum = sum + parseFloat(item.amount.replace(/,/g, ""));
          return parseFloat(sum);
        }, 0);

        return totAmt.toFixed(2);
      } catch (err) {
        return 0;
      }
    }
  };

  sleep = async milliseconds => {
    const date = Date.now();
    let currentDate = null;
    do {
      currentDate = Date.now();
    } while (currentDate - date < milliseconds);
  };

  generateMyOrders = () => {
    let currOrders = this.props.db["deliveryRequest"];
    let groupedOrders = _.chain(currOrders)
      .groupBy("mobile")
      .value();
    console.log(JSON.stringify(groupedOrders));
    this.props.firebase.db
      .ref("/myOrders")
      .once("value")
      .then(snap => {
        return snap.ref.set(groupedOrders);
      })
      .catch(err => {
        console.log("some error: " + err);
      })
      .then(err => {
        //console.log("Updated Rec: " + databucket[idField]);
      });
  };

  dataUpdateHandler = async (databucket, cloudPath) => {
    if (databucket && databucket.key && databucket.key !== "") {
      let ordTotal = this.getTotal(databucket.requestedItems);
      console.log(ordTotal);
      databucket["orderTotal"] = ordTotal;
      this.props.firebase.db
        .ref("/" + cloudPath + "/" + databucket.key + "/")
        .once("value")
        .then(snap => {
          return snap.ref.set(databucket);
        })
        .catch(err => {
          console.log("some error: " + err);
        })
        .then(err => {
          //console.log("Updated Rec: " + databucket[idField]);
        });
    }

    //this.props.handleEditCancel();
  };

  productsUpdateHandler = async (databucket, categoryKey) => {
    this.props.firebase.db
      .ref("/" + categoryKey + "/")
      .once("value")
      .then(snap => {
        return snap.ref.set(databucket);
      })
      .catch(err => {
        console.log("some error: " + err);
      })
      .then(err => {
        console.log("Updated Rec: " + key);
      });

    //this.props.handleEditCancel();
  };

  handleDelete = (key, path) => {
    this.props.firebase.db.ref("/" + path + "/" + key).remove();
  };

  archiveOrders = async allOrders => {
    // alert("Current Orders: " + allOrders.length);
    let freqProds = this.getFrequentlyOrder();
    //console.log(JSON.stringify(freqProds));
    alert("done");
    //let cuttOffDate = moment().subtract(30, "day");
    // for (let i = 0; i < allOrders.length; i++) {
    //   await this.dataUpdateHandler(allOrders[i], "deliveryRequest");
    //   await this.sleep(500);
    // }
  };

  updatePopular = async () => {
    let freqProds = this.getFrequentlyOrder();
    //await this.productsUpdateHandler(freqProds, "POPULAR");
    alert("Done");
  };

  repeatOrder = rec => {
    //console.log("ok baba " + JSON.stringify(rec));
    this.props.onAddArray({ path: "bucket", payload: rec.requestedItems });
    this.setScroll(true);
    this.stateChangeHandler("directOrderpad", "stage", false);
    this.stateChangeHandler("supplierShopItems", "tableName", false);
    this.stateChangeHandler(false, "showGrid", false);
  };

  genNotification = (payload, actionType) => {
    console.log(window.location.hostname);
    if (this.state.tableName === "openBazar") {
      if (payload && payload.message && payload.message !== "") {
        let notifyText =
          "BCS Open Bazar(" + payload.name + " says): " + payload.message;
        this.props.onNotifyUsers(notifyText, [], true);
      }
    }

    if (this.state.tableName === "deliveryRequest") {
      console.log("this is orders");
    }
    if (this.state.tableName === "supplierShopItems") {
      console.log("this is my shop");
    }
  };

  getSignedInAs = () => {
    if (
      this.props.firebase.auth &&
      this.props.firebase.auth.currentUser &&
      this.props.firebase.auth.currentUser.phoneNumber &&
      this.state.stage === "homepage"
    ) {
      return (
        <div
          style={{
            marginLeft: "20px",
            marginTop: "10px",
            width: "200px"
          }}
        >
          Signed in as {this.props.firebase.auth.currentUser.phoneNumber}
        </div>
      );
    }
    if (
      this.props.firebase.auth &&
      this.props.firebase.auth.currentUser &&
      this.props.firebase.auth.currentUser.phoneNumber &&
      (this.state.stage === "passportService" ||
        this.state.stage === "hCommService")
    ) {
      return (
        <div
          style={{
            marginLeft: "20px",
            marginTop: "10px",
            width: "200px"
          }}
        >
          BCS Passport Svc (BGD)
        </div>
      );
    }
    if (
      this.props.firebase.auth &&
      this.props.firebase.auth.currentUser &&
      this.props.firebase.auth.currentUser.phoneNumber &&
      (this.state.stage === "remitService" ||
        this.state.stage === "agraniService" ||
        this.state.stage === "primeService")
    ) {
      return (
        <div
          style={{
            marginLeft: "20px",
            marginTop: "10px",
            width: "200px"
          }}
        >
          BCS Remittance Svc (BDT)
        </div>
      );
    }
  };

  /*
  //stages & tables
  1. bcsHome - users | front page
  2. shopFromASupplier - supplierShopItems | order now
  3. directOrderpad - deliveryRequest | complete order
  5. selectCategory - ??no table?? | filter products

  7. openBazar - openBazar | open bazar


  8. addToShop - supplierShopItems | update products
  9. supplier - deliveryRequest | pick orders
  
  9. login - main login stage
  10. 

//roles
  1. WORKER
  2. STOREADMIN
  3. SUPERADMIN
*/

  getTopNav = () => {
    return (
      <div
        style={{
          height: "45px",
          border: "0px solid black",
          margin: "auto",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          position: "fixed",
          top: "0",
          width: "100%",
          maxWidth: "600px",
          zIndex: "25",
          margin: "0px",
          backgroundColor: "#ebebed",
          paddingTop: "5px",
          boxSizing:
            this.state.stage !== "login" &&
            this.state.stage !== "shopFromASupplier"
              ? "border-box"
              : null,
          boxShadow:
            this.state.stage !== "login" &&
            this.state.stage !== "shopFromASupplier"
              ? "0px 4px 4px rgba(0, 0, 0, 0.25)"
              : null
        }}
      >
        <div
          style={{
            border: "0px solid red",
            width: "80%"
          }}
        >
          {this.getViewOrdersButton()}
          {this.getAddMoreItemsButton()}
          {this.getNewOrderButton()}
          {this.getSearchBar()}
          {this.getSignedInAs()}
        </div>

        <div
          style={{
            border: "0px solid green",
            width: "150px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end"
          }}
        >
          {this.getHomeButton()}
          {this.getSupplierButton()}
          {this.getCloseButton()}
          {this.getAddPostPlusButton()}
          {this.getAddButton()}
          {this.getMenuButton()}
        </div>
      </div>
    );
  };

  getRemitAdmins = () => {
    if (
      this.props.currUserRole !== "SUPERADMIN" &&
      this.state.stage === "agraniService"
    ) {
      return (
        <div>
          {(this.props.cellPhone === "+6594562455" ||
            this.props.cellPhone === "+6597861234" ||
            this.props.cellPhone === "+6594562456") && (
            <AgraniService
              cellPhone={this.props.cellPhone}
              firebase={this.props.firebase}
              cancelHandler={() => {
                this.setScroll(true);
                this.stateChangeHandler({}, "searchFilters", false);
                this.stateChangeHandler("homepage", "stage", false);
                this.stateChangeHandler("users", "tableName", false);
                this.stateChangeHandler(true, "showGrid", false);
              }}
              myRemitRegs={this.props.db["agraniRegs"]}
              myRemitApps={this.props.db["agraniApps"]}
              selectedExchange="agrani"
              setScroll={this.setScroll}
              onSendEmail={this.props.onSendEmail}
              onNotifyUsers={this.props.onNotifyUsers}
            />
          )}
        </div>
      );
    }
    if (
      this.props.currUserRole !== "SUPERADMIN" &&
      this.state.stage === "primeService"
    ) {
      var appVersion = window.document.getElementById("appVersion");
      if (appVersion && appVersion !== undefined) {
        console.log(appVersion.value);
        return (
          <div>
            <PrimeExchService appVersion={appVersion.value} />
            {/* {(this.props.cellPhone === "+6594562455" ||
              this.props.cellPhone === "+6597861234" ||
              this.props.cellPhone === "+6594562456") && (
              <AgraniService
                cellPhone={this.props.cellPhone}
                firebase={this.props.firebase}
                cancelHandler={() => {
                  this.setScroll(true);
                  this.stateChangeHandler({}, "searchFilters", false);
                  this.stateChangeHandler("homepage", "stage", false);
                  this.stateChangeHandler("users", "tableName", false);
                  this.stateChangeHandler(true, "showGrid", false);
                }}
                myRemitRegs={this.props.db["primeRegs"]}
                myRemitApps={this.props.db["primeApps"]}
                selectedExchange={"prime"}
                setScroll={this.setScroll}
                onSendEmail={this.props.onSendEmail}
                onNotifyUsers={this.props.onNotifyUsers}
              />
            )} */}
          </div>
        );
      }
    }
  };

  getMainContent = () => {
    return (
      <div
        style={{
          maxWidth: "600px",
          margin: "auto"
        }}
      >
        {this.getTopNav()}
        {this.getMenuDiv()}
        {this.getOverLay()}
        {!this.state.isSignedIn &&
          this.state.stage === "login" &&
          this.getLoginPage()}
        {this.getHomePage()}
        {this.state.showGrid && (
          <div
            style={{
              marginTop: "60px",
              padding: "5px"
            }}
          >
            {this.getGrid()}
          </div>
        )}

        <div
          style={{
            marginTop: this.state.currUserRole === "SUPERADMIN" ? "60px" : "0px"
          }}
        >
          {this.state.currUserRole === "SUPERADMIN" &&
            this.state.showGrid &&
            this.getAdminGrid()}
          {this.props.currUserRole === "SUPERADMIN" && !this.state.showGrid && (
            <div
              style={{
                paddingLeft: "5px",
                paddingRight: "5px"
              }}
            >
              <SingleRecord
                path={this.state.tableName}
                handleEditCancel={() => {
                  this.backToList("superadmin", this.state.tableName);
                  this.stateChangeHandler(true, "showGrid");
                }}
                handleDelete={this.handleDelete}
                ogTableDef={getExtendedOgDefs(this.props.createTable)}
                genNotification={this.genNotification}
                cellPhone={this.state.refPhoneNumber}
              />
            </div>
          )}
        </div>

        {this.props.currUserRole !== "SUPERADMIN" &&
          this.state.stage === "shopFromASupplier" && (
            <div>
              <div
                style={{
                  position: "fixed",
                  top: "0px",
                  backgroundColor: "#ebebed",
                  borderTop: "1px solid white",
                  margin: "0px",
                  padding: "2px",
                  height: "90px",
                  zIndex: "5",
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-end",
                  padding: "2px",
                  overflowX: "scroll",
                  flexDirection: "row",
                  maxWidth: "600px",
                  boxSizing: "border-box",
                  boxShadow: "rgba(0,0,0,0.25) 0px 4px 4px"
                }}
              >
                {this.getCategTabs()}
              </div>
              <BuyFromShopGrid
                db={this.props.db}
                tableName={this.state.tableName}
                tableDef={this.state.tableDefs[this.state.tableName]}
                handleEdit={this.handleEdit}
                handleDelete={this.handleDelete}
                genDirectSupplierOrder={this.genDirectSupplierOrder}
                addToBucket={this.addToBucket}
                removeFromBucket={this.removeFromBucket}
                getBucketDetails={this.getBucketDetails}
                supplierName={this.state.selectedSupplier}
                supplierRole={
                  this.props.userProfile && this.props.userProfile["roleName"]
                    ? this.props.userProfile["roleName"]
                    : ""
                }
                searchVal={this.state.searchVal}
                role="all"
                searchFilters={this.state.searchFilters}
                //myProductsKeys={this.getPrevOrderProds()}
                loadPrevOrders={this.getPrevOrderProds}
                dataIsLoaded={
                  this.props.ui[this.state.tableName + "-downloaded"]
                }
                cellNumber={this.props.cellNumber}
              />
            </div>
          )}
        {this.props.currUserRole !== "SUPERADMIN" &&
          this.state.stage === "directOrderpad" && (
            <OrderPadDirectSupplier
              path={"deliveryRequest"}
              backToList={this.backToList}
              handleDelete={this.handleDelete}
              ogTableDef={getExtendedOgDefs(this.props.createTable)}
              genNotification={this.genNotification}
              cellPhone={this.state.refPhoneNumber}
              addToBucket={this.addToBucket}
              removeFromBucket={this.removeFromBucket}
              getBucketDetails={this.getBucketDetails}
              prodDets={this.state.prodDets}
              addMoreItems={() => {
                //console.log("doing new order  ");
                this.backToList(
                  "shopFromASupplier",
                  "supplierShopItems",
                  this.state.selectedSupplier
                );
                this.stateChangeHandler(true, "showGrid", false);
              }}
            />
          )}

        {this.props.currUserRole !== "SUPERADMIN" &&
          this.state.stage === "hCommService" &&
          (this.props.cellPhone === "+6594562455" ||
            this.props.cellPhone === "+6597861234" ||
            this.props.cellPhone === "+6594562456" ||
            this.props.cellPhone === "+6590169379") && (
            <div>
              <HighComm
                applications={this.props.db["hCommApps"]}
                firebase={this.props.firebase}
                onNotifyUsers={this.props.onNotifyUsers}
              />
            </div>
          )}

        {this.props.currUserRole !== "SUPERADMIN" &&
          this.state.stage === "remitServiceAdmin" &&
          (this.props.cellPhone === "+6594562455" ||
            this.props.cellPhone === "+6597861234" ||
            this.props.cellPhone === "+6594562456") && (
            <div>Money transfer Admin here</div>
          )}
        {this.props.currUserRole !== "SUPERADMIN" &&
          this.state.stage === "passportService" &&
          (this.props.cellPhone === "+6594562455" ||
            this.props.cellPhone === "+6597861234" ||
            this.props.cellPhone === "+6594562456" ||
            this.props.cellPhone === "+6590618524") && (
            <BgdPassportServiceExt
              cellPhone={this.props.cellPhone}
              firebase={this.props.firebase}
              cancelHandler={() => {
                this.setScroll(true);
                this.stateChangeHandler({}, "searchFilters", false);
                this.stateChangeHandler("homepage", "stage", false);
                this.stateChangeHandler("users", "tableName", false);
                this.stateChangeHandler(true, "showGrid", false);
              }}
              setScroll={this.setScroll}
            />
          )}

        {this.props.currUserRole !== "SUPERADMIN" &&
          this.state.stage === "remitService" &&
          (this.props.cellPhone === "+6594562455" ||
            this.props.cellPhone === "+6597861234" ||
            this.props.cellPhone === "+6594562456") && (
            <RemitService
              cellPhone={this.props.cellPhone}
              firebase={this.props.firebase}
              cancelHandler={() => {
                this.setScroll(true);
                this.stateChangeHandler({}, "searchFilters", false);
                this.stateChangeHandler("homepage", "stage", false);
                this.stateChangeHandler("users", "tableName", false);
                this.stateChangeHandler(true, "showGrid", false);
              }}
              myRemitRegs={this.props.db["myRemitRegs"]}
              myRemitApps={this.props.db["myRemitApps"]}
              setScroll={this.setScroll}
              onSendEmail={this.props.onSendEmail}
              onNotifyUsers={this.props.onNotifyUsers}
              onReachApi={this.props.onReachApi}
              agraniRates={this.props.db["agraniRates"]}
              primeRates={this.props.db["primeRates"]}
              regsReady={this.props.ui["myRemitRegs-downloaded"]}
              onAddRecord={this.props.onAddRecord}
              myRemitApplication={this.props.db["myRemitApplication"]}
            />
          )}

        {this.getRemitAdmins()}

        {this.props.currUserRole !== "SUPERADMIN" &&
          this.state.stage === "passportService" &&
          !(
            this.props.cellPhone === "+6594562455" ||
            this.props.cellPhone === "+6597861234" ||
            this.props.cellPhone === "+6594562456" ||
            this.props.cellPhone === "+6590618524"
          ) && (
            <BgdPassportServiceExt
              cellPhone={this.props.cellPhone}
              firebase={this.props.firebase}
              cancelHandler={() => {
                this.setScroll(true);
                this.stateChangeHandler({}, "searchFilters", false);
                this.stateChangeHandler("homepage", "stage", false);
                this.stateChangeHandler("users", "tableName", false);
                this.stateChangeHandler(true, "showGrid", false);
              }}
              setScroll={this.setScroll}
            />
          )}
        {this.props.currUserRole !== "SUPERADMIN" &&
          this.state.stage === "openBazar" && (
            <div
              style={{
                paddingLeft: "5px",
                paddingRight: "5px"
              }}
            >
              <SingleRecord
                path={this.state.tableName}
                handleEditCancel={() => {
                  this.backToList("openBazarList", "openBazar");
                  this.stateChangeHandler(true, "showGrid");
                }}
                handleDelete={(key, path, payload) => {
                  this.handleDelete(key, path, payload);
                  this.backToList("openBazarList", "openBazar");
                  this.stateChangeHandler(true, "showGrid");
                }}
                ogTableDef={getExtendedOgDefs(this.props.createTable)}
                genNotification={this.genNotification}
                cellPhone={this.state.refPhoneNumber}
              />
            </div>
          )}
        {!this.state.showGrid &&
          this.props.currUserRole === "STOREADMIN" &&
          this.state.stage === "addToShop" && (
            <SingleRecord
              path={this.state.tableName}
              handleEditCancel={() => {
                this.backToList("addToShop", "supplierShopItems");
                this.stateChangeHandler(true, "showGrid");
              }}
              handleDelete={this.handleDelete}
              ogTableDef={getExtendedOgDefs(this.props.createTable)}
              genNotification={this.genNotification}
              cellPhone={this.state.refPhoneNumber}
            />
          )}

        {!this.state.showGrid &&
          this.props.currUserRole === "STOREADMIN" &&
          this.state.stage === "storeAdminElse" && (
            <SingleRecord
              path={this.state.tableName}
              handleEditCancel={() => {
                this.backToList("storeAdminElse", this.state.tableName);
                this.stateChangeHandler(true, "showGrid");
              }}
              handleDelete={this.handleDelete}
              ogTableDef={getExtendedOgDefs(this.props.createTable)}
              genNotification={this.genNotification}
              cellPhone={this.state.refPhoneNumber}
            />
          )}

        {this.state.stage === "shopFromASupplier" &&
          this.getShopFromGridHeader()}
      </div>
    );
  };

  removeFromBucket = product => {
    let currBucket = _.cloneDeep(this.props.db["bucket"]);

    if (currBucket && currBucket.length > 0) {
      //update qty up if prod exists
      let tgtProd = currBucket.find(stateProd => stateProd.key === product.key);
      if (tgtProd && tgtProd !== undefined) {
        //console.log("bhaiya prod tow mil gaya");
        if (tgtProd.quantity > 1) {
          tgtProd.quantity = tgtProd.quantity - 1;
          tgtProd.amount = numeral(
            tgtProd.quantity * tgtProd.productPrice
          ).format("0,0.00");
        } else {
          //remove whole obj
          currBucket = currBucket.filter(
            stateProd => stateProd.key !== product.key
          );
          //console.log(JSON.stringify(currBucket));
        }

        this.props.onAddArray({
          path: "bucket",
          payload: currBucket
        });
      }
    }
  };

  getShopFromGridHeader = () => {
    let currBucket = _.cloneDeep(this.props.db["bucket"]);

    if (currBucket && currBucket.length > 0) {
      let totAmt = currBucket.reduce((sum, item) => {
        sum = sum + parseFloat(item.amount.replace(/,/g, ""));
        return parseFloat(sum);
      }, 0);
      return (
        <div
          style={{
            textAlign: "center",
            position: "fixed",
            maxWidth: "600px",
            bottom: "0px",
            width: "100%",
            margin: "auto",
            textAlign: "center",
            backgroundColor: "white",
            padding: "0px",
            display: "flex",
            border: "1px solid grey",
            boxSizing: "border-box",
            boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.5)",
            zIndex: "5"
          }}
        >
          <div
            style={{
              borderRadius: "5px",
              color: "black",
              backgroundColor: "white",
              fontSize: "18px",
              cursor: "pointer",
              fontWeight: "bold",
              width: "50%",
              height: "40px",
              textAlign: "center",
              opacity: 1,

              margin: "5px"
            }}
          >
            <div>
              <span
                style={{ fontSize: "10px", magin: "3px", marginLeft: "10px" }}
              >
                Total:
              </span>
              {" $"}
              {numeral(totAmt).format("0,0.00")}
            </div>
            <div>
              <span style={{ fontSize: "10px", margin: "3px" }}>Items: </span>{" "}
              {currBucket.length}
            </div>
          </div>

          <div
            style={{
              padding: "0.6em 0.6em",
              borderRadius: "8px",
              color: "#fff",
              backgroundColor: "rgb(30, 101, 144)",

              fontSize: "1.1em",
              border: "0px",
              cursor: "pointer",
              margin: "5px",
              fontWeight: "bold",
              border: "1px solid white",
              width: "50%"
            }}
            onClick={() => {
              this.setScroll(true);
              this.stateChangeHandler("directOrderpad", "stage", false);
              this.stateChangeHandler(false, "showGrid", false);
            }}
          >
            <span>
              <icon
                className="fa fa-shopping-bag"
                style={{ color: "white", margin: "5px" }}
              />
            </span>
            VIEW BAG
          </div>
        </div>
      );
    }
  };

  getBucketDetails = product => {
    let currBucket = _.cloneDeep(this.props.db["bucket"]);
    if (currBucket && currBucket.length > 0) {
      let tgtProd = currBucket.find(stateProd => stateProd.key === product.key);
      if (tgtProd && tgtProd !== undefined) {
        return tgtProd;
      }
    }
  };

  addToBucket = product => {
    //console.log("Adding " + JSON.stringify(product));
    let bucketObj = { ...product, quantity: 1 };
    bucketObj.amount = numeral(
      bucketObj.productPrice * bucketObj.quantity
    ).format("0,0.00");
    let currBucket = _.cloneDeep(this.props.db["bucket"]);

    if (currBucket && currBucket.length > 0) {
      //update qty up if prod exists
      let tgtProd = currBucket.find(
        stateProd => stateProd.key === bucketObj.key
      );
      if (tgtProd && tgtProd !== undefined) {
        //console.log("bhaiya prod tow mil gaya");
        tgtProd.quantity = tgtProd.quantity + 1;
        tgtProd.amount = numeral(
          tgtProd.quantity * tgtProd.productPrice
        ).format("0,0.00");
      } else {
        currBucket.push(bucketObj);
      }
      this.props.onAddArray({
        path: "bucket",
        payload: currBucket
      });
    } else {
      this.props.onAddArray({
        path: "bucket",
        payload: [bucketObj]
      });
    }
  };

  handleEdit = (key, path, fullPayload) => {
    window.document.querySelector("#oDiv").scroll(0, 0);
    this.props.onSelectRecord({ path: path, key: key });
    this.stateChangeHandler(false, "showGrid", false);
    this.props.onSetUiFlag("operationType", "update");
  };

  genDirectSupplierOrder = rec => {
    this.stateChangeHandler(rec, "prodDets", false);
    this.stateChangeHandler("directOrderpad", "stage", false);
    let initData = getInitData(
      "deliveryRequest",
      this.props.createTable,
      this.props.userProfile
    );

    if (initData && initData !== undefined) {
      this.props.onSetUiFlag("operationType", "add");
      this.props.onSetUiFlag("tableName", "deliveryRequest");
      this.props.onAddNew({
        path: this.state.tableName,
        data: { ...initData }
      });
    } else {
      console.log("no init");
      // console.log(
      //   "tableName: " +
      //     this.state.tableName +
      //     " crTable: " +
      //     JSON.stringify(this.props.createTable) +
      //     " " +
      //     JSON.stringify(initData)
      // );
    }
    this.setScroll(true);
  };

  getLandingPage = () => {
    let tmpEmail = "";
    let tmpPassword = "";

    if (this.refs.email && this.refs.email.value) {
      console.log(this.refs.email.value);
      tmpEmail = this.refs.email.value;
    }

    if (this.refs.password && this.refs.password.value) {
      console.log(this.refs.password.value);
      tmpPassword = this.refs.password.value;
    }

    return (
      <DirectAdmin
        company={this.state.refPhoneNumber}
        email={tmpEmail}
        password={tmpPassword}
        stateChangeHandler={this.stateChangeHandler}
        switchMenu={this.switchMenu}
      />
    );
  };

  render() {
    return (
      <div
        style={{
          width: "100%",
          overflowX: "hidden"
        }}
        id={"oDiv"}
      >
        {this.props.loginProgress && (
          <div
            style={{
              margin: "auto",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh"
            }}
          >
            <img
              src={logoB64Text}
              style={{
                height: "100px",
                width: "100px",
                borderRadius: "100px",
                animation: "rotation 2s infinite linear",
                perspective: "1000px"
              }}
            />
          </div>
        )}
        {!this.props.loginProgress && (
          <div>
            {this.props.currUserRole === "SUPERADMIN" && this.getTopMenu()}
            <div>
              {this.state.stage === "admin" && this.getLandingPage()}
              <div>
                {this.state.stage !== "admin" &&
                  this.state.stage !== "text" &&
                  this.getMainContent()}
              </div>
            </div>

            {this.state.showGrid &&
              this.state.stage === "supplierShopItems" &&
              this.getSearchBar()}
            <div
              style={{
                height: "300px"
              }}
            ></div>
            {this.getHiddenControls()}
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userProfile: state.db.userProfile,
    users: state.db.users,
    isAdmin: state.ui.isThisAdmin,
    isSuperAdmin: state.ui.isThisSuperAdmin,
    userUid: state.ui.userUid,
    currUserRole: state.ui.currUserRole,
    createTable: state.db.createTable,
    testTable: state.db.testTable,
    listOfTables: state.db.listOfTables,
    menuDesigner: state.db.menuDesigner,
    cellPhone: state.ui.cellPhone,
    uploadButton:
      state.ui.dataUploadButton && state.ui.dataUploadButton !== undefined
        ? state.ui.dataUploadButton
        : false,
    db: state.db,
    operationType: state.ui.operationType,
    loginProgress: state.ui.loginProgress,
    notLoadedBasicData: state.ui.notLoadedBasicData,
    userMenus: state.ui.userMenus,
    workerMenus: state.ui.workerMenus,
    listYPos: state.ui.listYPos,
    orderStage: state.ui.orderStage,
    ui: state.ui
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onAddRecord: data => dispatch(actionAddArray2Redux(data)),
    onUpdateRecord: data => dispatch(actionUpdateRecord2Redux(data)),
    onSelectRecord: params => {
      dispatch(selectARecord(params));
      dispatch(setUiFlag("tableName", params.path));
    },
    onAddNew: data => dispatch(initSelectedRecord(data)),
    loadStats: parsedRes => dispatch(loadAllStats(parsedRes)),
    onSetUiFlag: (flagName, flagVal) => dispatch(setUiFlag(flagName, flagVal)),
    onSignOut: () => {
      dispatch(resetRedux());
      dispatch(setUiFlag("userMenus", []));
    },
    loadFbData: (tableName, firebase, onceOnly, subPath, singleObj) =>
      dispatch(loadFbData(tableName, firebase, onceOnly, subPath, singleObj)),
    onNotifyUsers: (msgBody, arrayOfUsers, sendToAll) =>
      dispatch(notifyUsers(msgBody, arrayOfUsers, sendToAll)),
    onGetId: data => dispatch(getId(data)),
    onGetAcctStatement: data => dispatch(getAcctStatement(data)),
    onGetAcctBalance: data => dispatch(getAcctBalance(data)),
    onAddArray: data => dispatch(actionAddArray2Redux(data)),
    onFetchDistance: (og, dst) => dispatch(fetchDistance(og, dst)),
    onInitialFetch: (tableName, url, accessToken) =>
      dispatch(initialFetch(tableName, url, accessToken)),
    onInitialProductsFetch: (url, accessToken) =>
      dispatch(initialProductsFetch(url, accessToken)),
    onReachApi: async objContents => dispatch(reachApi(objContents)),
    onReachApiExtended: async objContents =>
      dispatch(reachApiExtended(objContents)),
    onSendEmail: mailParams =>
      dispatch(getStatementB64(undefined, undefined, mailParams))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(Workers);



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/Workers.jsx